"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var index_exports = {};
__export(index_exports, {
  ActionType: () => ActionType,
  ComponentType: () => ComponentType,
  CreateFilterUpdateEventPayload: () => CreateFilterUpdateEventPayload,
  EventType: () => EventType,
  ItemType: () => ItemType,
  PageType: () => PageType,
  PaymentType: () => PaymentType,
  SearchCategory: () => SearchCategory,
  SearchType: () => SearchType,
  SiteId: () => SiteId,
  SiteVertical: () => SiteVertical,
  UserStatus: () => UserStatus,
  addPaymentInfoEvent: () => addPaymentInfoEvent,
  addToCartEvent: () => addToCartEvent,
  beginCheckoutEvent: () => beginCheckoutEvent,
  checkoutErrorEvent: () => checkoutErrorEvent,
  createAddPaymentInfoEvent: () => createAddPaymentInfoEvent,
  createAddToCartEvent: () => createAddToCartEvent,
  createBeginCheckoutEvent: () => createBeginCheckoutEvent,
  createCheckoutErrorEvent: () => createCheckoutErrorEvent,
  createCreditCardAddEvent: () => createCreditCardAddEvent,
  createCreditCardAddEventPayload: () => createCreditCardAddEventPayload,
  createCreditCardApplyEvent: () => createCreditCardApplyEvent,
  createCreditCardApplyEventPayload: () => createCreditCardApplyEventPayload,
  createCtaClickEvent: () => createCtaClickEvent,
  createCtaClickEventPayload: () => createCtaClickEventPayload,
  createCustomClickEvent: () => createCustomClickEvent,
  createFilterApplyEvent: () => createFilterApplyEvent,
  createFilterOpenEvent: () => createFilterOpenEvent,
  createFilterOpenEventPayload: () => createFilterOpenEventPayload,
  createFilterSelectEvent: () => createFilterSelectEvent,
  createFilterUpdateEvent: () => createFilterUpdateEvent,
  createFooterClickEvent: () => createFooterClickEvent,
  createFormCompleteEvent: () => createFormCompleteEvent,
  createFormErrorEvent: () => createFormErrorEvent,
  createHolidaysFilterApplyEventPayload: () => createHolidaysFilterApplyEventPayload,
  createHolidaysFilterSelectEventPayload: () => createHolidaysFilterSelectEventPayload,
  createHolidaysViewItemListEventPayload: () => createHolidaysViewItemListEventPayload,
  createHolidaysViewSearchResultsEventPayload: () => createHolidaysViewSearchResultsEventPayload,
  createHotelsAddToCartEventPayload: () => createHotelsAddToCartEventPayload,
  createHotelsBeginCheckoutEventPayload: () => createHotelsBeginCheckoutEventPayload,
  createHotelsOptimizelyFeatureDecisionEventPayload: () => createHotelsOptimizelyFeatureDecisionEventPayload,
  createHotelsPurchaseEventPayload: () => createHotelsPurchaseEventPayload,
  createHotelsSelectItemEventPayload: () => createHotelsSelectItemEventPayload,
  createHotelsViewItemEventPayload: () => createHotelsViewItemEventPayload,
  createHotelsViewItemListEventPayload: () => createHotelsViewItemListEventPayload,
  createHotelsViewSearchResultsEventPayload: () => createHotelsViewSearchResultsEventPayload,
  createLoginEvent: () => createLoginEvent,
  createLoginEventPayload: () => createLoginEventPayload,
  createLogoutEvent: () => createLogoutEvent,
  createLogoutEventPayload: () => createLogoutEventPayload,
  createMapLocationClickEvent: () => createMapLocationClickEvent,
  createMapLocationClickPayload: () => createMapLocationClickPayload,
  createMapOpenClickEvent: () => createMapOpenClickEvent,
  createMapOpenClickEventPayload: () => createMapOpenClickEventPayload,
  createMenuClickEvent: () => createMenuClickEvent,
  createModalCloseEvent: () => createModalCloseEvent,
  createModalCloseEventPayload: () => createModalCloseEventPayload,
  createModalShowEvent: () => createModalShowEvent,
  createOptimizelyFeatureDecisionEvent: () => createOptimizelyFeatureDecisionEvent,
  createPageViewEvent: () => createPageViewEvent,
  createPageViewEventPayload: () => createPageViewEventPayload,
  createPaginationClickEvent: () => createPaginationClickEvent,
  createPaginationClickEventPayload: () => createPaginationClickEventPayload,
  createPromotionCodeApplyEvent: () => createPromotionCodeApplyEvent,
  createPurchaseEvent: () => createPurchaseEvent,
  createSearchErrorEvent: () => createSearchErrorEvent,
  createSearchErrorEventPayload: () => createSearchErrorEventPayload,
  createSearchExitFieldEvent: () => createSearchExitFieldEvent,
  createSearchExitFieldEventPayload: () => createSearchExitFieldEventPayload,
  createSearchSubmitEvent: () => createSearchSubmitEvent,
  createSearchSubmitEventPayload: () => createSearchSubmitEventPayload,
  createSearchSuggestionClickEvent: () => createSearchSuggestionClickEvent,
  createSearchSuggestionDisplayEvent: () => createSearchSuggestionDisplayEvent,
  createSelectItemEvent: () => createSelectItemEvent,
  createSelectPromotionEvent: () => createSelectPromotionEvent,
  createSortApplyEvent: () => createSortApplyEvent,
  createSortApplyEventPayload: () => createSortApplyEventPayload,
  createSortOpenEvent: () => createSortOpenEvent,
  createSortOpenEventPayload: () => createSortOpenEventPayload,
  createSortSelectEvent: () => createSortSelectEvent,
  createSortSelectEventPayload: () => createSortSelectEventPayload,
  createTabClickEvent: () => createTabClickEvent,
  createTabClickEventPayload: () => createTabClickEventPayload,
  createTileClickEvent: () => createTileClickEvent,
  createTileClickEventPayload: () => createTileClickEventPayload,
  createUserPayload: () => createUserPayload,
  createViewItemEvent: () => createViewItemEvent,
  createViewItemListEvent: () => createViewItemListEvent,
  createViewPromotionEvent: () => createViewPromotionEvent,
  createViewSearchResultsEvent: () => createViewSearchResultsEvent,
  ctaClickEvent: () => ctaClickEvent,
  customClickEvent: () => customClickEvent,
  filterUpdateEvent: () => filterUpdateEvent,
  loginEvent: () => loginEvent,
  logoutEvent: () => logoutEvent,
  menuClickEvent: () => menuClickEvent,
  pageViewEvent: () => pageViewEvent,
  promotionCodeApplyEvent: () => promotionCodeApplyEvent,
  purchaseEvent: () => purchaseEvent,
  searchExitFieldEvent: () => searchExitFieldEvent,
  searchSubmitEvent: () => searchSubmitEvent,
  searchSuggestionClickEvent: () => searchSuggestionClickEvent,
  searchSuggestionDisplayEvent: () => searchSuggestionDisplayEvent,
  selectHolidaysItemEvent: () => selectHolidaysItemEvent,
  selectItemEvent: () => selectItemEvent,
  selectPromotionEvent: () => selectPromotionEvent,
  tabClickEvent: () => tabClickEvent,
  viewItemEvent: () => viewItemEvent,
  viewItemListEvent: () => viewItemListEvent,
  viewPromotionEvent: () => viewPromotionEvent
});
module.exports = __toCommonJS(index_exports);

// src/enums/action-type.ts
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["ADD"] = "add";
  ActionType2["ADD_PAYMENT"] = "add_payment";
  ActionType2["APPLY"] = "apply";
  ActionType2["CLICK"] = "click";
  ActionType2["CLOSE"] = "close";
  ActionType2["COMPLETE"] = "complete";
  ActionType2["CREATE"] = "create";
  ActionType2["DISPLAY"] = "display";
  ActionType2["ERROR"] = "error";
  ActionType2["EXIT_FIELD"] = "exit_field";
  ActionType2["LOCATION_CLICK"] = "location_click";
  ActionType2["LOGIN"] = "login";
  ActionType2["LOGOUT"] = "logout";
  ActionType2["NEXT"] = "next";
  ActionType2["OPEN"] = "open";
  ActionType2["PREVIOUS"] = "previous";
  ActionType2["PURCHASE"] = "purchase";
  ActionType2["SELECT"] = "select";
  ActionType2["SHOW"] = "show";
  ActionType2["START"] = "start";
  ActionType2["SUBMIT"] = "submit";
  ActionType2["UPDATE"] = "update";
  ActionType2["VIEW"] = "view";
  return ActionType2;
})(ActionType || {});

// src/enums/component-type.ts
var ComponentType = /* @__PURE__ */ ((ComponentType2) => {
  ComponentType2["ACCORDION"] = "accordion";
  ComponentType2["ADYEN_PAYMENT_WIDGET"] = "adyen_payment_widget";
  ComponentType2["CARD"] = "card";
  ComponentType2["CAROUSEL"] = "carousel";
  ComponentType2["CART"] = "cart";
  ComponentType2["CHAT"] = "chat";
  ComponentType2["CHECKOUT"] = "checkout";
  ComponentType2["CTA"] = "cta";
  ComponentType2["CUSTOM"] = "custom";
  ComponentType2["FILTER"] = "filter";
  ComponentType2["FILTER_SORT_MODAL"] = "filter_sort_modal";
  ComponentType2["FOOTER"] = "footer";
  ComponentType2["FORM"] = "form";
  ComponentType2["GALLERY"] = "gallery";
  ComponentType2["ITEM"] = "item";
  ComponentType2["ITEM_LIST"] = "item_list";
  ComponentType2["MAP"] = "map";
  ComponentType2["MAP_MODAL"] = "map_modal";
  ComponentType2["MENU"] = "menu";
  ComponentType2["MODAL"] = "modal";
  ComponentType2["PAGINATION"] = "pagination";
  ComponentType2["PROMOTION_CODE"] = "promotion_code";
  ComponentType2["PROMOTION_LIST"] = "promotion_list";
  ComponentType2["SEARCH"] = "search";
  ComponentType2["SEARCH_ERROR"] = "search_error";
  ComponentType2["SEARCH_PANEL"] = "search_panel";
  ComponentType2["SEARCH_RESULTS"] = "search_results";
  ComponentType2["SORT"] = "sort";
  ComponentType2["TAB"] = "tab";
  ComponentType2["TILE"] = "tile";
  ComponentType2["TOOLTIP"] = "tooltip";
  return ComponentType2;
})(ComponentType || {});

// src/enums/event-type.ts
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["ADD_PAYMENT_INFO"] = "add_payment_info";
  EventType2["ADD_TO_CART"] = "add_to_cart";
  EventType2["BEGIN_CHECKOUT"] = "begin_checkout";
  EventType2["CHECKOUT_ERROR"] = "checkout_error";
  EventType2["CREDIT_CARD_ADD"] = "credit_card_add";
  EventType2["CREDIT_CARD_APPLY"] = "credit_card_apply";
  EventType2["CTA_CLICK"] = "cta_click";
  EventType2["CUSTOM_CLICK"] = "custom_click";
  EventType2["FILTER_APPLY"] = "filter_apply";
  EventType2["FILTER_OPEN"] = "filter_open";
  EventType2["FILTER_SELECT"] = "filter_select";
  EventType2["FILTER_UPDATE"] = "filter_update";
  EventType2["FOOTER_CLICK"] = "footer_click";
  EventType2["FORM_COMPLETE"] = "form_complete";
  EventType2["FORM_ERROR"] = "form_error";
  EventType2["LOGIN"] = "login";
  EventType2["LOGOUT"] = "logout";
  EventType2["MAP_LOCATION_CLICK"] = "map_location_click";
  EventType2["MAP_OPEN"] = "map_open";
  EventType2["MENU_CLICK"] = "menu_click";
  EventType2["MODAL_CLOSE"] = "modal_close";
  EventType2["MODAL_SHOW"] = "modal_show";
  EventType2["OPTIMIZELY_FEATURE_DECISION"] = "optimizely_feature_decision";
  EventType2["PAGE_VIEW"] = "page_view";
  EventType2["PAGINATION_CLICK"] = "pagination_click";
  EventType2["PROMOTION_CODE_APPLY"] = "promotion_code_apply";
  EventType2["PURCHASE"] = "purchase";
  EventType2["SEARCH_ERROR"] = "search_error";
  EventType2["SEARCH_EXIT_FIELD"] = "search_exit_field";
  EventType2["SEARCH_SUBMIT"] = "search_submit";
  EventType2["SEARCH_SUGGESTION_CLICK"] = "search_suggestion_click";
  EventType2["SEARCH_SUGGESTION_DISPLAY"] = "search_suggestion_display";
  EventType2["SELECT_ITEM"] = "select_item";
  EventType2["SELECT_PROMOTION"] = "select_promotion";
  EventType2["SORT_APPLY"] = "sort_apply";
  EventType2["SORT_OPEN"] = "sort_open";
  EventType2["SORT_SELECT"] = "sort_select";
  EventType2["TAB_CLICK"] = "tab_click";
  EventType2["TILE_CLICK"] = "tile_click";
  EventType2["VIEW_ITEM"] = "view_item";
  EventType2["VIEW_ITEM_LIST"] = "view_item_list";
  EventType2["VIEW_PROMOTION"] = "view_promotion";
  EventType2["VIEW_SEARCH_RESULTS"] = "view_search_results";
  return EventType2;
})(EventType || {});

// src/enums/page-type.ts
var PageType = /* @__PURE__ */ ((PageType2) => {
  PageType2["ACTIVITIES"] = "Activities Page";
  PageType2["AIRBNB"] = "Airbnb Page";
  PageType2["AUTH"] = "Auth Page";
  PageType2["BOOKING"] = "Booking Page";
  PageType2["BOOKING_CANCELLATION"] = "Booking Cancellation Page";
  PageType2["BOOKING_CONFIRMATION"] = "Booking Confirmation Page";
  PageType2["BOOKING_DETAILS"] = "Booking Details Page";
  PageType2["CAMPAIGNS"] = "Campaigns Page";
  PageType2["CHANGE_DATES"] = "Change Dates Page";
  PageType2["CHANGE_DATE_REQUEST"] = "Change Date Request Page";
  PageType2["CONTACT_US"] = "Contact Us Page";
  PageType2["DEALS"] = "Deals Page";
  PageType2["DESTINATION"] = "Destination Page";
  PageType2["EMAIL_US_FORM"] = "Email Us Form Page";
  PageType2["EXCLUSIVE_OFFER"] = "Exclusive Offer Page";
  PageType2["FAQS"] = "FAQs Page";
  PageType2["FIND_BOOKING"] = "Find Booking Page";
  PageType2["HOME"] = "Home Page";
  PageType2["LATEST_BOOKINGS"] = "Latest Bookings Page";
  PageType2["LOGIN"] = "Login Page";
  PageType2["LOGIN_REDIRECTION"] = "Login Redirection Page";
  PageType2["LOGOUT"] = "Logout Page";
  PageType2["MAP"] = "Map Page";
  PageType2["MY_BOOKINGS"] = "My Bookings Page";
  PageType2["PRINT_BOOKING_DETAILS"] = "Print Booking Details Page";
  PageType2["PROPERTY"] = "Property Page";
  PageType2["SEARCH"] = "Search Page";
  PageType2["UNKNOWN"] = "Unknown Page";
  return PageType2;
})(PageType || {});

// src/enums/search-category.ts
var SearchCategory = /* @__PURE__ */ ((SearchCategory2) => {
  SearchCategory2["AIRBNB"] = "airbnb";
  SearchCategory2["JETSTAR"] = "jetstar";
  SearchCategory2["QANTAS"] = "qantas";
  return SearchCategory2;
})(SearchCategory || {});

// src/enums/search-type.ts
var SearchType = /* @__PURE__ */ ((SearchType2) => {
  SearchType2["LIST"] = "list";
  SearchType2["MAP"] = "map";
  return SearchType2;
})(SearchType || {});

// src/enums/site-ids.ts
var SiteId = /* @__PURE__ */ ((SiteId2) => {
  SiteId2["HOLIDAYS"] = "holidays";
  SiteId2["HOTELS"] = "hotels";
  SiteId2["SELF_SERVICE"] = "self-service";
  return SiteId2;
})(SiteId || {});

// src/enums/site-verticals.ts
var SiteVertical = /* @__PURE__ */ ((SiteVertical2) => {
  SiteVertical2["TRAVEL"] = "travel";
  return SiteVertical2;
})(SiteVertical || {});

// src/enums/user-status.ts
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["LOGGED_IN"] = "logged in";
  UserStatus2["LOGGED_OUT"] = "logged out";
  return UserStatus2;
})(UserStatus || {});

// src/enums/item-type.ts
var ItemType = /* @__PURE__ */ ((ItemType2) => {
  ItemType2["BUTTON"] = "button";
  ItemType2["DROPDOWN"] = "dropdown";
  ItemType2["LINK"] = "link";
  return ItemType2;
})(ItemType || {});

// src/enums/payment-type.ts
var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
  PaymentType2["CASH"] = "cash";
  PaymentType2["CASH_AND_POINTS"] = "cash and points";
  PaymentType2["POINTS"] = "points";
  return PaymentType2;
})(PaymentType || {});

// src/event-creators/createEventCreator/createEventCreator.ts
var createEventCreator = (event) => (eventPayload) => ({
  event,
  ...eventPayload
});

// src/event-creators/event-creators.ts
var createAddPaymentInfoEvent = createEventCreator("add_payment_info" /* ADD_PAYMENT_INFO */);
var createAddToCartEvent = createEventCreator("add_to_cart" /* ADD_TO_CART */);
var createBeginCheckoutEvent = createEventCreator("begin_checkout" /* BEGIN_CHECKOUT */);
var createCheckoutErrorEvent = createEventCreator("checkout_error" /* CHECKOUT_ERROR */);
var createCtaClickEvent = createEventCreator("cta_click" /* CTA_CLICK */);
var createCustomClickEvent = createEventCreator("custom_click" /* CUSTOM_CLICK */);
var createFilterApplyEvent = createEventCreator("filter_apply" /* FILTER_APPLY */);
var createFilterOpenEvent = createEventCreator("filter_open" /* FILTER_OPEN */);
var createFilterSelectEvent = createEventCreator("filter_select" /* FILTER_SELECT */);
var createFilterUpdateEvent = createEventCreator("filter_update" /* FILTER_UPDATE */);
var createFormErrorEvent = createEventCreator("form_error" /* FORM_ERROR */);
var createFooterClickEvent = createEventCreator("footer_click" /* FOOTER_CLICK */);
var createFormCompleteEvent = createEventCreator("form_complete" /* FORM_COMPLETE */);
var createLoginEvent = createEventCreator("login" /* LOGIN */);
var createLogoutEvent = createEventCreator("logout" /* LOGOUT */);
var createMenuClickEvent = createEventCreator("menu_click" /* MENU_CLICK */);
var createModalShowEvent = createEventCreator("modal_show" /* MODAL_SHOW */);
var createModalCloseEvent = createEventCreator("modal_close" /* MODAL_CLOSE */);
var createPageViewEvent = createEventCreator("page_view" /* PAGE_VIEW */);
var createPromotionCodeApplyEvent = createEventCreator("promotion_code_apply" /* PROMOTION_CODE_APPLY */);
var createPurchaseEvent = createEventCreator("purchase" /* PURCHASE */);
var createSearchExitFieldEvent = createEventCreator("search_exit_field" /* SEARCH_EXIT_FIELD */);
var createSearchSubmitEvent = createEventCreator("search_submit" /* SEARCH_SUBMIT */);
var createSearchSuggestionClickEvent = createEventCreator(
  "search_suggestion_click" /* SEARCH_SUGGESTION_CLICK */
);
var createSearchSuggestionDisplayEvent = createEventCreator(
  "search_suggestion_display" /* SEARCH_SUGGESTION_DISPLAY */
);
var createSelectItemEvent = createEventCreator("select_item" /* SELECT_ITEM */);
var createSelectPromotionEvent = createEventCreator("select_promotion" /* SELECT_PROMOTION */);
var createSortApplyEvent = createEventCreator("sort_apply" /* SORT_APPLY */);
var createSortOpenEvent = createEventCreator("sort_open" /* SORT_OPEN */);
var createSortSelectEvent = createEventCreator("sort_select" /* SORT_SELECT */);
var createTabClickEvent = createEventCreator("tab_click" /* TAB_CLICK */);
var createTileClickEvent = createEventCreator("tile_click" /* TILE_CLICK */);
var createViewItemEvent = createEventCreator("view_item" /* VIEW_ITEM */);
var createViewItemListEvent = createEventCreator("view_item_list" /* VIEW_ITEM_LIST */);
var createViewPromotionEvent = createEventCreator("view_promotion" /* VIEW_PROMOTION */);
var createSearchErrorEvent = createEventCreator("search_error" /* SEARCH_ERROR */);
var createViewSearchResultsEvent = createEventCreator("view_search_results" /* VIEW_SEARCH_RESULTS */);
var createPaginationClickEvent = createEventCreator("pagination_click" /* PAGINATION_CLICK */);
var createMapLocationClickEvent = createEventCreator("map_location_click" /* MAP_LOCATION_CLICK */);
var createMapOpenClickEvent = createEventCreator("map_open" /* MAP_OPEN */);
var createOptimizelyFeatureDecisionEvent = createEventCreator(
  "optimizely_feature_decision" /* OPTIMIZELY_FEATURE_DECISION */
);
var createCreditCardAddEvent = createEventCreator("credit_card_add" /* CREDIT_CARD_ADD */);
var createCreditCardApplyEvent = createEventCreator("credit_card_apply" /* CREDIT_CARD_APPLY */);

// src/data-helpers/createSearchSubmitEventPayload/createSearchSubmitEventPayload.ts
var createSearchSubmitEventPayload = ({
  componentType,
  pageType,
  componentVariant
}) => {
  return {
    event_data: {
      action: "submit",
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant
    }
  };
};

// src/data-helpers/createSortApplyEventPayload/createSortApplyEventPayload.ts
var createSortApplyEventPayload = ({
  componentType,
  pageType,
  componentVariant,
  sortField,
  sortOrder
}) => {
  return {
    event_data: {
      action: "apply" /* APPLY */,
      sort_field: sortField,
      sort_order: sortOrder,
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant
    }
  };
};

// src/data-helpers/createSortOpenEventPayload/createSortOpenEventPayload.tsx
var createSortOpenEventPayload = ({
  componentType,
  componentVariant,
  pageType
}) => {
  return {
    event_data: {
      action: "open" /* OPEN */,
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant
    }
  };
};

// src/data-helpers/createSortSelectEventPayload/createSortSelectEventPayload.ts
var createSortSelectEventPayload = ({
  componentType,
  pageType,
  componentVariant,
  sortField,
  sortOrder
}) => {
  return {
    event_data: {
      action: "select" /* SELECT */,
      sort_field: sortField,
      sort_order: sortOrder,
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant
    }
  };
};

// src/data-helpers/createHolidaysFilterApplyEventPayload/createHolidaysFilterApplyEventPayload.tsx
var import_general = require("@qantasexperiences/utils/general");
var createHolidaysFilterApplyEventPayload = ({
  componentType,
  componentVariant,
  itemRatings,
  maxPrice,
  minPrice,
  pageType,
  defaultMinPrice,
  defaultMaxPrice,
  minPricePercentage,
  maxPricePercentage
}) => {
  const priceData = (0, import_general.removeNullAndUndefinedEntries)({
    filter_price_max_range: maxPrice,
    filter_price_min_range: minPrice,
    filter_price_default_min: defaultMinPrice,
    filter_price_default_max: defaultMaxPrice,
    filter_price_min_range_perc: minPricePercentage,
    filter_price_max_range_perc: maxPricePercentage
  });
  return {
    event_data: {
      component_type: componentType,
      component_variant: componentVariant,
      page_type: pageType,
      filter_item_rating: itemRatings.sort().join(", "),
      ...priceData
    }
  };
};

// src/data-helpers/createHolidaysFilterSelectEventPayload/createHolidaysFilterSelectEventPayload.tsx
var createHolidaysFilterSelectEventPayload = ({
  componentType,
  componentVariant,
  itemRatings,
  maxPrice,
  minPrice,
  pageType
}) => {
  return {
    component_type: componentType,
    component_variant: componentVariant,
    page_type: pageType,
    filter_item_rating: itemRatings.sort().join(", "),
    filter_price_max_range: maxPrice.toString(),
    filter_price_min_range: minPrice.toString()
  };
};

// src/data-helpers/createHolidaysViewSearchResultsEventPayload/createHolidaysViewSearchResultsEventPayload.ts
var createHolidaysViewSearchResultsEventPayload = (eventData) => {
  const {
    action,
    availablePackageCount,
    componentType,
    destination,
    duration,
    endDate,
    origin,
    pageType,
    searchPaymentToggle,
    searchType,
    startDate,
    travellersAdult,
    travellersChildren,
    travellersInfant
  } = eventData;
  return {
    event_data: {
      action,
      available_package_count: availablePackageCount,
      component_type: componentType,
      destination,
      duration,
      end_date: endDate,
      origin,
      page_type: pageType,
      search_payment_toggle: searchPaymentToggle,
      search_type: searchType,
      start_date: startDate,
      travellers_adult: travellersAdult,
      travellers_children: travellersChildren,
      travellers_infant: travellersInfant
    }
  };
};

// src/data-helpers/createHolidaysViewItemListEventPayload/createHolidaysViewItemListEventPayload.tsx
var import_lodash = require("lodash");
var createHolidaysViewItemListEventPayload = ({
  destinationName,
  eventData,
  ecommerceItems
}) => {
  const {
    action,
    availablePackageCount,
    componentType,
    destination,
    duration,
    endDate,
    origin,
    pageType,
    searchPaymentToggle,
    searchType,
    startDate,
    travellersAdult,
    travellersChildren,
    travellersInfant
  } = eventData;
  const name = `${destinationName} holidays`;
  const items = ecommerceItems.map(
    ({
      hasOffer,
      index,
      itemCategory,
      itemId,
      itemName,
      itemVariant,
      pointsValue,
      price,
      quantity
    }) => {
      return {
        has_offer: hasOffer,
        index,
        item_category: itemCategory,
        item_id: itemId,
        item_name: itemName,
        item_variant: itemVariant,
        points_value: pointsValue,
        price,
        quantity
      };
    }
  );
  return {
    event_data: {
      action,
      available_package_count: availablePackageCount,
      component_type: componentType,
      destination,
      duration,
      end_date: endDate,
      origin,
      page_type: pageType,
      search_payment_toggle: searchPaymentToggle,
      search_type: searchType,
      start_date: startDate,
      travellers_adult: travellersAdult,
      travellers_children: travellersChildren,
      travellers_infant: travellersInfant
    },
    ecommerce: {
      currency: "AUD",
      item_list_id: (0, import_lodash.snakeCase)(name),
      item_list_name: name,
      items
    }
  };
};

// src/data-helpers/createFilterOpenEventPayload/createFilterOpenEventPayload.tsx
var createFilterOpenEventPayload = ({
  componentType,
  componentVariant,
  pageType
}) => {
  return {
    event_data: {
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant
    }
  };
};

// src/data-helpers/createHotelsBeginCheckoutEventPayload/createHotelsBeginCheckoutEventPayload.ts
var import_decimal4 = require("decimal.js");

// src/utils/cash-to-points.ts
var import_decimal = require("decimal.js");
var cashToPoints = (cash, tiers) => {
  const absCash = new import_decimal.Decimal(cash).abs();
  const points = tiers.levels.reduce((total, tier) => {
    if (absCash.greaterThanOrEqualTo(tier.min)) {
      const tierMax = (max) => max ? max : new import_decimal.Decimal(Infinity);
      const pointsAmountForTier = import_decimal.Decimal.min(tierMax(tier.max), absCash).minus(tier.min).dividedBy(tier.rate);
      return total.plus(pointsAmountForTier);
    }
    return total;
  }, new import_decimal.Decimal(0)).toDecimalPlaces(0, import_decimal.Decimal.ROUND_HALF_EVEN);
  return cash.isNegative() ? points.neg() : points;
};

// src/utils/payment-type.ts
var getPaymentType = ({ cash, points, creditCard, creditNote, voucher, qantasGroupCreditVoucher }, isDepositPay = false) => {
  const paymentTypes = isDepositPay ? ["deposit pay"] : [];
  if (cash?.greaterThan(0)) paymentTypes.push("cash");
  if (points?.greaterThan(0)) paymentTypes.push("points");
  if (creditCard?.greaterThan(0)) paymentTypes.push("credit card");
  if (creditNote?.greaterThan(0)) paymentTypes.push("credit note");
  if (voucher?.greaterThan(0)) paymentTypes.push("voucher");
  if (qantasGroupCreditVoucher?.greaterThan(0)) paymentTypes.push("Qantas Group credit voucher");
  if (paymentTypes.length > 1) {
    const last = paymentTypes.pop();
    return `${paymentTypes.join(", ")} and ${last}`;
  } else if (paymentTypes[0]) {
    return paymentTypes[0];
  }
  return "no payments";
};

// src/data-helpers/hotelsUtils/hotelsUtils.ts
var import_date_fns = require("date-fns");
var import_decimal3 = require("decimal.js");

// src/utils/points-to-cash.ts
var import_decimal2 = require("decimal.js");
var pointsToCash = (points, tiers) => {
  const absPoints = points.abs();
  const cashAmount = tiers.levels.reduce(
    (total, tier) => {
      if (absPoints.greaterThan(total.points)) {
        const maxPointsForTier = tier.max.minus(tier.min).dividedBy(tier.rate);
        const pointsForTier = import_decimal2.Decimal.min(maxPointsForTier, absPoints.minus(total.points));
        const cashAmountForTier = pointsForTier.times(tier.rate);
        return {
          cash: total.cash.plus(cashAmountForTier),
          points: total.points.plus(pointsForTier)
        };
      }
      return total;
    },
    { cash: new import_decimal2.Decimal(0), points: new import_decimal2.Decimal(0) }
  ).cash;
  const resultAmount = points.isNegative() ? cashAmount.neg() : cashAmount;
  return resultAmount.toDecimalPlaces(2, import_decimal2.Decimal.ROUND_HALF_EVEN);
};

// src/data-helpers/hotelsUtils/hotelsUtils.ts
var calculateDailyRate = (totalAmount2, totalNights2) => {
  return Number(new import_decimal3.Decimal(totalAmount2).dividedBy(totalNights2));
};
var calculateDailyPreDiscountAmount = (amount, nights) => {
  return Number(new import_decimal3.Decimal(amount).dividedBy(nights).toDecimalPlaces(2));
};
var calculateDailyTotalAmount = (amount, totalNights2) => {
  return Number(new import_decimal3.Decimal(amount).dividedBy(totalNights2));
};
var calculatePointsPaidPercentage = (points, amount) => {
  if (points.greaterThan(0)) {
    return Number(points.dividedBy(new import_decimal3.Decimal(amount)).times(100).toFixed(2));
  }
  return 0;
};
var calculateTotalNights = (checkIn, checkOut) => {
  return (0, import_date_fns.differenceInDays)(new Date(checkOut), new Date(checkIn));
};
var createLocationString = (city, state, country) => {
  return `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country}`;
};
var formatDate = (date) => {
  const parsedDate = new Date(date);
  return (0, import_date_fns.format)(parsedDate, "yyyy-MM-dd");
};
var isPromotionExclusive = (promotionName) => {
  return !!promotionName?.toLowerCase().includes("exclusive");
};
var isPropertyLuxury = (promotionName) => {
  return !!promotionName?.toLowerCase().includes("luxury");
};
var totalInCashBeforeDiscount = (isPoints, amount, pointsConversion) => {
  if (isPoints) {
    return Number(pointsToCash(new import_decimal3.Decimal(amount), pointsConversion));
  }
  return Number(amount);
};
var totalNights = (checkIn, checkOut) => {
  return (0, import_date_fns.differenceInDays)(new Date(checkOut), new Date(checkIn));
};
var calculateTotalPointsValueAnyPayWith = (charges, pointsConversion) => {
  const { total, totalCash } = charges;
  if (totalCash?.amount) {
    return total.amount;
  }
  return cashToPoints(new import_decimal3.Decimal(total.amount), pointsConversion).toNumber();
};
var getTotalPrice = (charges) => {
  const { total, totalCash } = charges;
  if (!totalCash?.amount) {
    return new import_decimal3.Decimal(total.amount).toNumber();
  }
  return new import_decimal3.Decimal(totalCash.amount).toNumber();
};
var calculateId = (listName) => {
  return listName.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_");
};

// src/data-helpers/createHotelsBeginCheckoutEventPayload/createHotelsBeginCheckoutEventPayload.ts
var createHotelsBeginCheckoutEventPayload = ({
  ctaMessage,
  ctaMessageCategory,
  isRebooked,
  payments,
  pointsConversion,
  quote
}) => {
  const startDate = formatDate(quote.stay.checkIn);
  const endDate = formatDate(quote.stay.checkOut);
  const totalNights2 = calculateTotalNights(quote.stay.checkIn, quote.stay.checkOut);
  const { city, state, country } = quote.property.address;
  const location = createLocationString(city, state, country);
  const totalPointsValue = cashToPoints(
    new import_decimal4.Decimal(quote.offer.charges.total.amount),
    pointsConversion
  );
  const hasStrikethroughPrice = Number(quote.offer.charges.strikethrough?.price.amount) > 0;
  return {
    event_data: {
      action: "start" /* START */,
      component_type: "checkout" /* CHECKOUT */,
      ...ctaMessage && { cta_message: ctaMessage },
      ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
      strikethrough_price: hasStrikethroughPrice
    },
    ecommerce: {
      value: Number(quote.offer.charges.total.amount),
      currency: quote.offer.charges.total.currency,
      items: [
        {
          item_id: quote.property.id,
          item_name: quote.property.name,
          item_category: quote.property.category,
          item_variant: quote.roomType.name,
          index: 0,
          quantity: totalNights2,
          price: calculateDailyRate(new import_decimal4.Decimal(quote.offer.charges.total.amount), totalNights2),
          original_price: calculateDailyPreDiscountAmount(
            Number(quote.offer.charges.totalBeforeDiscount.amount),
            totalNights2
          ),
          cash_used: Number(payments.cash.payableNow.amount),
          points_used: Number(payments.points.amount),
          points_value: Number(totalPointsValue),
          points_earned: Number(quote.offer.pointsEarned?.qffPoints.total),
          pay_in_points_percent: calculatePointsPaidPercentage(
            new import_decimal4.Decimal(payments.points.amount ?? 0),
            totalPointsValue
          ),
          rating: quote.property.rating,
          start_date: startDate,
          end_date: endDate,
          travellers_adult: quote.stay.adults,
          travellers_children: quote.stay.children,
          travellers_infant: quote.stay.infants,
          number_of_nights: totalNights2,
          includes: quote.roomType.roomTypeFacilities.join(", "),
          payment_type: getPaymentType({
            cash: new import_decimal4.Decimal(quote.offer.charges.payableAtProperty.total.amount),
            creditCard: new import_decimal4.Decimal(payments.cash.payableNow.amount ?? 0),
            voucher: new import_decimal4.Decimal(payments.voucher.amount ?? 0),
            points: new import_decimal4.Decimal(payments.points.amount ?? 0)
          }),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International",
          luxe: isPropertyLuxury(quote.offer.promotion?.name ?? void 0),
          exclusive_offer: isPromotionExclusive(quote.offer.promotion?.name ?? void 0),
          rebook: isRebooked,
          has_offer: !!quote.offer.promotion?.name,
          offer_type: quote.offer.promotion?.name ?? void 0,
          strikethrough_price: hasStrikethroughPrice,
          ...ctaMessage && { cta_message: ctaMessage },
          ...ctaMessageCategory && { cta_message_category: ctaMessageCategory }
        }
      ]
    }
  };
};

// src/data-helpers/createHotelsAddToCartEventPayload/createHotelsAddToCartEventPayload.ts
var import_decimal5 = require("decimal.js");
var createHotelsAddToCartEventPayload = ({
  property,
  offer,
  roomType,
  query,
  initialCash,
  pointsConversion,
  isRebooked,
  ctaMessage,
  ctaMessageCategory
}) => {
  const startDate = formatDate(new Date(query.checkIn));
  const endDate = formatDate(new Date(query.checkOut));
  const { amount: totalInCash, currency: totalCurrency } = offer.charges.total.currency === "PTS" ? offer.charges.totalCash ?? {} : offer.charges.total;
  const { city, state, country } = property.address;
  const location = `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country}`;
  const numberOfNights = totalNights(query.checkIn, query.checkOut);
  const price = totalInCash ? calculateDailyTotalAmount(totalInCash, numberOfNights) : 0;
  const cashBeforeDiscount = totalInCashBeforeDiscount(
    offer.charges.totalBeforeDiscount.currency === "PTS",
    offer.charges.totalBeforeDiscount.amount,
    pointsConversion
  );
  const cashUsed = offer.charges.total.currency === "PTS" ? initialCash : offer.charges.total.amount;
  const pointsUsed = offer.charges.total.currency === "PTS" ? new import_decimal5.Decimal(offer.charges.total.amount).minus(
    cashToPoints(new import_decimal5.Decimal(initialCash), pointsConversion)
  ) : new import_decimal5.Decimal(0);
  const hasStrikethroughPrice = Number(offer.charges.strikethrough?.price.amount) > 0;
  return {
    event_data: {
      component_type: "cart" /* CART */,
      location: "Property Page" /* PROPERTY */,
      ...ctaMessage && { cta_message: ctaMessage },
      ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
      strikethrough_price: hasStrikethroughPrice
    },
    ecommerce: {
      value: Number(totalInCash),
      currency: totalCurrency ?? "AUD",
      items: [
        {
          item_id: property.id,
          item_name: property.name,
          item_category: property.category,
          item_variant: roomType.name,
          item_offer: offer.name,
          index: 0,
          quantity: numberOfNights,
          price,
          original_price: calculateDailyPreDiscountAmount(cashBeforeDiscount, numberOfNights),
          cash_used: Number(cashUsed),
          points_used: Number(pointsUsed),
          points_value: totalInCash ? cashToPoints(new import_decimal5.Decimal(totalInCash), pointsConversion).toNumber() : 0,
          points_earned: Number(offer.pointsEarned?.qffPoints.total),
          pay_in_points_percentage: calculatePointsPaidPercentage(
            pointsUsed,
            offer.charges.total.amount
          ),
          rating: property.rating,
          start_date: startDate,
          end_date: endDate,
          travellers_adult: query.adults,
          travellers_children: query.children,
          travellers_infant: query.infants,
          number_of_nights: numberOfNights,
          number_of_rooms: 1,
          includes: roomType.roomTypeFacilities?.join(", ") ?? "",
          payment_type: getPaymentType({
            cash: new import_decimal5.Decimal(cashUsed),
            points: new import_decimal5.Decimal(pointsUsed)
          }),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International",
          luxe: isPropertyLuxury(offer.promotion?.name ?? void 0),
          exclusive_offer: isPromotionExclusive(offer.promotion?.name ?? void 0),
          rebook: isRebooked,
          has_offer: !!offer.promotion?.name,
          offer_type: offer.promotion?.name ?? void 0,
          ...ctaMessage && { cta_message: ctaMessage },
          ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
          strikethrough_price: hasStrikethroughPrice
        }
      ]
    }
  };
};

// src/data-helpers/createHotelsPurchaseEventPayload/createHotelsPurchaseEventPayload.ts
var import_decimal6 = require("decimal.js");

// src/utils/points-totals.ts
var getPointsTotals = (totalAmount2, { voucher, creditCard, creditNote, qantasGroupCreditVoucher, points }) => {
  const pointsInCash = totalAmount2.minus(voucher).minus(creditNote).minus(qantasGroupCreditVoucher).minus(creditCard);
  const pointsPayPercentage = points.greaterThan(0) ? pointsInCash.dividedBy(totalAmount2).times(100).toFixed(2) : 0;
  return {
    pointsInCash,
    pointsPayPercentage
  };
};

// src/data-helpers/createHotelsPurchaseEventPayload/createHotelsPurchaseEventPayload.ts
var createHotelsPurchaseEventPayload = ({
  booking,
  quote,
  isRebooked,
  ctaMessage,
  ctaMessageCategory
}) => {
  const methods = {
    creditCard: new import_decimal6.Decimal(booking.bookingTotal.creditCard.total ?? 0),
    creditNote: new import_decimal6.Decimal(booking.bookingTotal.creditNote.total ?? 0),
    points: new import_decimal6.Decimal(booking.bookingTotal.points.totalPoints ?? 0),
    qantasGroupCreditVoucher: new import_decimal6.Decimal(booking.bookingTotal.qantasGroupCreditVoucher.total ?? 0),
    voucher: new import_decimal6.Decimal(booking.bookingTotal.voucher.total ?? 0)
  };
  const totalAmount2 = new import_decimal6.Decimal(booking.reservation.offer.charges.payableAtBooking.total.amount);
  const discountAmount = new import_decimal6.Decimal(quote.offer.charges.payableAtBooking.discount.amount);
  const preDiscountTotal = new import_decimal6.Decimal(quote.offer.charges.totalBeforeDiscount.amount);
  const { pointsPayPercentage } = getPointsTotals(totalAmount2, methods);
  const isDepositPay = !!quote.offer.paidByDeposit;
  const depositPayPercentage = isDepositPay ? methods.creditCard.dividedBy(totalAmount2).times(100).round().toNumber() : 0;
  const totalNights2 = calculateTotalNights(
    booking.reservation.checkIn,
    booking.reservation.checkOut
  );
  const { city, state, country } = booking.reservation.property.address;
  const location = createLocationString(city, state, country);
  const hasStrikethroughPrice = Number(quote.offer.charges.strikethrough?.price.amount) > 0;
  return {
    event_data: {
      action: "purchase" /* PURCHASE */,
      component_type: "checkout" /* CHECKOUT */,
      ...ctaMessage && { cta_message: ctaMessage },
      ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
      strikethrough_price: hasStrikethroughPrice
    },
    ecommerce: {
      transaction_id: booking.id,
      currency: booking.reservation.offer.charges.total.currency,
      value: totalAmount2.toNumber(),
      tax: Number(booking.reservation.offer.charges.payableAtBooking.taxDisplayable.amount),
      shipping: 0,
      total_cash_used: methods.creditCard.toNumber(),
      deposit_pay_percentage: depositPayPercentage,
      total_points_earned: booking.reservation.offer.pointsEarned?.qffPoints.total ?? 0,
      total_points_used_percentage: pointsPayPercentage,
      total_points_used: methods.points.toNumber(),
      total_points_value: booking.value.currency === "PTS" ? Number(booking.value.amount) : cashToPoints(totalAmount2, booking.reservation.offer.pointsTierInstance).toNumber(),
      payment_type: getPaymentType(methods, isDepositPay),
      voucher_value: methods.voucher.toNumber(),
      discount_value: Number(discountAmount),
      coupon: booking.reservation.offer.promotion?.promotionCode,
      voucher_used: !!methods.voucher.toNumber(),
      items: [
        {
          item_id: booking.reservation.property.id,
          item_name: booking.reservation.property.name,
          item_category: booking.reservation.property.category,
          item_variant: booking.reservation.roomType.name,
          item_offer: booking.reservation.offer.name,
          index: 0,
          price: calculateDailyTotalAmount(totalAmount2, totalNights2),
          original_price: calculateDailyPreDiscountAmount(preDiscountTotal, totalNights2),
          cash_used: methods.creditCard.toNumber(),
          points_used: methods.points.toNumber(),
          points_earned: booking.reservation.offer.pointsEarned?.qffPoints.total ?? 0,
          pay_in_points_percentage: pointsPayPercentage,
          rating: Number(booking.reservation.property.rating ?? 0),
          start_date: booking.reservation.checkIn.toString(),
          end_date: booking.reservation.checkOut.toString(),
          travellers_adult: booking.reservation.adults,
          travellers_children: booking.reservation.children,
          travellers_infant: booking.reservation.infants,
          number_of_nights: totalNights2,
          number_of_rooms: 1,
          includes: booking.reservation.roomType.roomTypeFacilities.join(", "),
          payment_type: getPaymentType(methods, isDepositPay),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International",
          luxe: isPropertyLuxury(booking.reservation.offer.promotion?.name ?? void 0),
          exclusive_offer: isPromotionExclusive(
            booking.reservation.offer.promotion?.name ?? void 0
          ),
          rebook: isRebooked,
          has_offer: !!booking.reservation.offer.promotion,
          offer_type: booking.reservation.offer.promotion?.name ?? void 0,
          strikethrough_price: hasStrikethroughPrice,
          ...ctaMessage && { cta_message: ctaMessage },
          ...ctaMessageCategory && { cta_message_category: ctaMessageCategory }
        }
      ]
    }
  };
};

// src/data-helpers/createHotelsViewItemEventPayload/createHotelsViewItemEventPayload.ts
var createHotelsViewItemEventPayload = ({
  adults,
  availableOffers,
  availableRooms,
  averagePointsEarned,
  averagePrice,
  averagePriceBeforeDiscount,
  averagePricePoints,
  checkIn,
  checkOut,
  children,
  ctaMessage,
  ctaMessageCategory,
  currency,
  infants,
  location,
  luxuryOffer,
  payWith,
  rebook,
  recommendedProperty,
  results,
  strikethrough
}) => {
  const startDate = formatDate(new Date(checkIn));
  const endDate = formatDate(new Date(checkOut));
  const numberOfNights = totalNights(checkIn, checkOut);
  const hasStrikethroughPrice = Number(strikethrough?.price.amount) > 0;
  return {
    event_data: {
      action: "view" /* VIEW */,
      component_type: "item" /* ITEM */,
      ...ctaMessage && { cta_message: ctaMessage },
      ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
      strikethrough_price: hasStrikethroughPrice
    },
    ecommerce: {
      value: averagePrice,
      currency,
      items: [
        {
          item_id: results.property.id,
          item_name: results.property.name,
          item_category: results.property.category,
          item_variant: void 0,
          item_offer: void 0,
          index: 0,
          quantity: 1,
          price: averagePrice,
          original_price: averagePriceBeforeDiscount,
          cash_used: void 0,
          points_used: void 0,
          points_value: averagePricePoints,
          points_earned: averagePointsEarned,
          pay_in_points_percentage: void 0,
          rating: results.property.rating,
          start_date: startDate,
          end_date: endDate,
          travellers_adult: adults,
          travellers_children: children,
          travellers_infant: infants,
          number_of_nights: numberOfNights,
          number_of_rooms: 1,
          includes: results.property.facilities,
          payment_type: payWith,
          location,
          international_or_domestic: results.property.internationalOrDomestic,
          luxe: luxuryOffer,
          recommend: recommendedProperty,
          rebook,
          offer_type: void 0,
          available_offer_count: availableOffers,
          available_room_count: availableRooms,
          image_count: results.property.imageCount,
          ...ctaMessage && { cta_message: ctaMessage },
          ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
          strikethrough_price: hasStrikethroughPrice
        }
      ]
    }
  };
};

// src/data-helpers/createUserPayload/createUserPayload.ts
var createUserPayload = ({
  userId,
  qffHashId,
  isLoggedIn,
  qffPoints
}) => {
  return {
    user_id: userId,
    user_qff_hash: qffHashId,
    user_login_status: isLoggedIn ? "logged in" /* LOGGED_IN */ : "logged out" /* LOGGED_OUT */,
    user_points: qffPoints
  };
};

// src/data-helpers/createPageViewEventPayload/createPageViewEventPayload.ts
var createPageViewEventPayload = ({
  siteId,
  siteVertical,
  location,
  referrer,
  pageType,
  pageTitle,
  user: user2
}) => {
  return {
    event_data: {
      action: "view" /* VIEW */
    },
    site: {
      site_id: siteId,
      site_vertical: siteVertical
    },
    content: {
      page_location: location,
      page_referrer: referrer,
      page_type: pageType,
      page_title: pageTitle
    },
    user: createUserPayload(user2)
  };
};

// src/data-helpers/createHotelsSelectItemEventPayload/createHotelsSelectItemEventPayload.ts
var createHotelsSelectItemEventPayload = ({
  availableProperties,
  availableRooms,
  category,
  listName,
  location,
  offer,
  payWith,
  pointsConversion,
  property,
  query,
  roomType,
  type,
  ctaMessage,
  ctaMessageCategory
}) => {
  const numberOfNights = totalNights(query.checkIn, query.checkOut);
  const totalPointsValue = calculateTotalPointsValueAnyPayWith(offer.charges, pointsConversion);
  const totalPrice = getTotalPrice(offer.charges);
  const hasStrikethroughPrice = Number(offer.charges.strikethrough?.price.amount) > 0;
  const id = calculateId(listName);
  const startDate = formatDate(new Date(query.checkIn));
  const endDate = formatDate(new Date(query.checkOut));
  return {
    event_data: {
      action: "click" /* CLICK */,
      component_type: "item_list" /* ITEM_LIST */,
      search_term: location,
      search_type: type,
      search_category: category,
      search_payment_toggle: payWith,
      ...availableProperties && {
        available_property_count: availableProperties
      },
      ...availableRooms && {
        available_room_count: availableRooms
      },
      start_date: startDate,
      end_date: endDate,
      travellers_adult: query.adults,
      travellers_children: query.children,
      travellers_infant: query.infants,
      ...ctaMessage && { cta_message: ctaMessage },
      ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
      strikethrough_price: hasStrikethroughPrice
    },
    ecommerce: {
      currency: offer.charges.totalCash?.currency ?? offer.charges.total.currency,
      item_list_id: id,
      item_list_name: listName,
      items: [
        {
          item_id: property.id,
          item_name: property.name,
          item_category: property.category,
          ...roomType?.name && { item_variant: roomType.name },
          index: 0,
          quantity: numberOfNights,
          price: totalPrice,
          points_value: totalPointsValue,
          has_offer: !!offer.promotion,
          has_deposit_pay: offer.depositPay.depositPayable,
          ...ctaMessage && { cta_message: ctaMessage },
          ...ctaMessageCategory && { cta_message_category: ctaMessageCategory },
          strikethrough_price: hasStrikethroughPrice
        }
      ]
    }
  };
};

// src/data-helpers/createCtaClickEventPayload/createCtaClickEventPayload.ts
var createCtaClickEventPayload = ({
  itemText,
  itemType,
  url,
  pageType,
  componentVariant,
  componentType
}) => {
  const payload = {
    event_data: {
      action: "click" /* CLICK */,
      component_type: componentType ?? "cta" /* CTA */,
      item_text: itemText,
      item_type: itemType,
      url
    }
  };
  if (componentVariant !== void 0) {
    payload.event_data.component_variant = componentVariant;
  }
  if (pageType !== void 0) {
    payload.event_data.page_type = pageType;
  }
  return payload;
};

// src/data-helpers/createHotelsViewSearchResultsEventPayload/createHotelsViewSearchResultsEventPayload.ts
var createHotelsViewSearchResultsEventPayload = ({
  availablePropertyCount,
  destinationName,
  destinationType,
  destinationDomesticType,
  endDate,
  startDate,
  paymentType,
  searchCategory,
  searchTerm,
  totalPropertyCount,
  viewMode,
  adults,
  children,
  infants
}) => {
  return {
    event_data: {
      action: "view" /* VIEW */,
      component_type: "search_results" /* SEARCH_RESULTS */,
      search_term: searchTerm,
      view_mode: viewMode,
      search_category: searchCategory,
      payment_type: paymentType,
      available_property_count: availablePropertyCount,
      total_property_count: totalPropertyCount,
      end_date: formatDate(endDate),
      start_date: formatDate(startDate),
      destination_name: destinationName,
      destination_type: destinationType,
      ...destinationDomesticType && { destination_domestic_type: destinationDomesticType },
      travellers_adult: adults,
      travellers_children: children,
      travellers_infant: infants
    }
  };
};

// src/data-helpers/createSearchErrorEventPayload/createSearchErrorEventPayload.ts
var createSearchErrorEventPayload = ({
  errors,
  searchTerm,
  url,
  pageType
}) => {
  return {
    event_data: {
      action: "error" /* ERROR */,
      component_type: "search" /* SEARCH */,
      errors: errors.map((error) => ({
        code: error.code,
        message: error.message,
        name: error.name
      })),
      search_term: searchTerm,
      url,
      page_type: pageType
    }
  };
};

// src/data-helpers/createLoginEventPayload/createLoginEventPayload.ts
var createLoginEventPayload = ({
  pageType,
  isLoggedIn,
  userId,
  userPoints,
  userQffHash,
  method = "hard"
}) => {
  const payload = {
    event_data: {
      action: "login" /* LOGIN */,
      method
    },
    user: createUserPayload({
      userId,
      qffHashId: userQffHash,
      isLoggedIn,
      qffPoints: userPoints
    })
  };
  if (pageType !== void 0) {
    payload.event_data.page_type = pageType;
  }
  return payload;
};

// src/data-helpers/createHotelsViewItemListEventPayload/createHotelsViewItemListEventPayload.ts
var createHotelsViewItemListEventPayload = ({
  listName,
  location,
  currency,
  type,
  category,
  payWith,
  availableProperties,
  availableRooms,
  checkIn,
  checkOut,
  adults,
  children,
  infants,
  results,
  pointsConversion
}) => {
  const numberOfNights = calculateTotalNights(checkIn, checkOut);
  return {
    event_data: {
      action: "view" /* VIEW */,
      component_type: "item_list" /* ITEM_LIST */,
      search_term: location,
      search_type: type,
      search_category: category,
      search_payment_toggle: payWith,
      available_property_count: availableProperties ?? null,
      available_room_count: availableRooms ?? null,
      ...checkIn && {
        start_date: formatDate(checkIn)
      },
      ...checkOut && { end_date: formatDate(checkOut) },
      travellers_adult: adults,
      travellers_children: children,
      travellers_infant: infants
    },
    ecommerce: {
      currency,
      item_list_id: calculateId(listName),
      item_list_name: listName,
      items: results.map(({ property, roomType, offer }, index) => {
        const pointsValue = calculateTotalPointsValueAnyPayWith(offer.charges, pointsConversion);
        const cashValue = getTotalPrice(offer.charges);
        const hasStrikethroughPrice = Number(offer.charges.strikethrough?.price.amount) > 0;
        return {
          item_id: property.id,
          item_name: property.name,
          item_variant: roomType.name,
          item_category: property.category,
          index,
          quantity: numberOfNights,
          price: cashValue,
          points_value: pointsValue,
          ...property.ctaMessage && { cta_message: property.ctaMessage },
          ...property.ctaMessageCategory && { cta_message_category: property.ctaMessageCategory },
          has_offer: property.hasOffer,
          strikethrough_price: hasStrikethroughPrice
        };
      })
    }
  };
};

// src/data-helpers/createPaginationClickEventPayload/createPaginationClickEventPayload.ts
var createPaginationClickEventPayload = ({
  action,
  componentType,
  pageType,
  itemText,
  itemType,
  url
}) => {
  return {
    action,
    component_type: componentType,
    page_type: pageType,
    item_text: itemText,
    item_type: itemType,
    url
  };
};

// src/data-helpers/createSearchExitFieldEventPayload/createSearchExitFieldEventPayload.ts
var createSearchExitFieldEventPayload = ({
  action,
  componentType,
  componentVariant,
  itemName,
  itemType,
  itemValue,
  pageType
}) => {
  const payload = {
    action,
    component_type: componentType,
    item_name: itemName,
    item_type: itemType,
    item_value: itemValue,
    page_type: pageType
  };
  if (componentVariant !== void 0) {
    payload.component_variant = componentVariant;
  }
  return payload;
};

// src/data-helpers/createMapOpenClickEventPayload/createMapOpenClickEventPayload.ts
var createMapOpenClickEventPayload = ({
  action,
  componentType,
  componentVariant,
  pageType,
  itemType
}) => {
  return {
    event_data: {
      action,
      item_type: itemType,
      component_type: componentType,
      page_type: pageType,
      component_variant: componentVariant
    }
  };
};

// src/data-helpers/createMapLocationClickPayload/createMapLocationClickPayload.ts
var createMapLocationClickPayload = ({
  groupName,
  itemName
}) => ({
  event_data: {
    action: "location_click" /* LOCATION_CLICK */,
    component_type: "map" /* MAP */,
    group_name: groupName,
    item_name: itemName
  }
});

// src/data-helpers/createFilterUpdateEventPayload/createFilterUpdateEventPayload.ts
var CreateFilterUpdateEventPayload = ({
  groupName,
  itemName,
  itemText,
  itemType,
  itemValue
}) => {
  return {
    event_data: {
      action: "update" /* UPDATE */,
      component_type: "filter" /* FILTER */,
      group_name: groupName,
      item_name: itemName,
      item_text: itemText,
      item_type: itemType,
      item_value: itemValue
    }
  };
};

// src/data-helpers/createHotelsOptimizelyFeatureDecisionEventPayload/createHotelsOptimizelyFeatureDecisionEventPayload.ts
var FXP_VARIANT_REGEX = /^([a-z0-9-]+_[a-z0-9-]+_[a-z0-9-]+)(,[a-z0-9-]+_[a-z0-9-]+_[a-z0-9-]+)*$/;
var createHotelsOptimizelyFeatureDecisionEventPayload = ({
  enabled,
  fxp_variant_string
}) => {
  if (!FXP_VARIANT_REGEX.test(fxp_variant_string)) {
    throw new Error(
      `fxp_variant_string must be in the format 'flagKey_variationKey_ruleKey' (kebab-case, separated by underscores, multiple experiments separated by commas). Received: ${fxp_variant_string}`
    );
  }
  const enabledString = String(enabled);
  return {
    optimizely: {
      fxp_variant_string,
      enabled: enabledString
    }
  };
};

// src/data-helpers/createTileClickEventPayload/createTileClickEventPayload.ts
var createTileClickEventPayload = ({
  action,
  componentType,
  itemText,
  itemName,
  url,
  index,
  groupName
}) => {
  const payload = {
    event_data: {
      action,
      component_type: componentType,
      group_name: groupName,
      item_name: itemName,
      item_text: itemText ?? "",
      index,
      url: url ?? ""
    }
  };
  return payload;
};

// src/data-helpers/createModalCloseEventPayload/createModalCloseEventPayload.ts
var createModalCloseEventPayload = ({
  componentType,
  componentVariant,
  pageType
}) => {
  return {
    event_data: {
      action: "close" /* CLOSE */,
      item_type: "button" /* BUTTON */,
      component_type: componentType,
      page_type: pageType,
      component_variant: componentVariant,
      url: window.location.href
    }
  };
};

// src/data-helpers/createLogoutEventPayload/createLogoutEventPayload.ts
var createLogoutEventPayload = ({
  pageType,
  userQffHash
}) => {
  const user2 = createUserPayload({
    userId: userQffHash,
    // keep it same as qffHash to align with the loyalty and qantas.com ecosystem
    qffHashId: userQffHash,
    isLoggedIn: false,
    qffPoints: void 0
  });
  const { user_points, ...userWithoutPoints } = user2;
  return {
    event_data: {
      action: "logout" /* LOGOUT */,
      page_type: pageType
    },
    user: userWithoutPoints
  };
};

// src/data-helpers/createCreditCardAddEventPayload/createCreditCardAddEventPayload.ts
var createCreditCardAddEventPayload = ({
  itemName,
  itemType,
  paymentType,
  provider,
  savedCard,
  url
}) => {
  return {
    event_data: {
      action: "add" /* ADD */,
      component_type: "adyen_payment_widget" /* ADYEN_PAYMENT_WIDGET */,
      item_name: itemName,
      item_type: itemType,
      payment_type: paymentType,
      provider,
      saved_card: savedCard,
      url
    }
  };
};

// src/data-helpers/createCreditCardApplyEventPayload/createCreditCardApplyEventPayload.ts
var createCreditCardApplyEventPayload = ({
  itemName,
  itemType,
  paymentType,
  provider,
  savedCard,
  url
}) => {
  return {
    event_data: {
      action: "apply" /* APPLY */,
      component_type: "adyen_payment_widget" /* ADYEN_PAYMENT_WIDGET */,
      item_name: itemName,
      item_type: itemType,
      payment_type: paymentType,
      provider,
      saved_card: savedCard,
      url
    }
  };
};

// src/data-helpers/createTabClickEventPayload/createTabClickEventPayload.ts
var createTabClickEventPayload = ({
  componentType,
  componentVariant,
  pageType
}) => {
  return {
    event_data: {
      action: "click" /* CLICK */,
      item_type: "button" /* BUTTON */,
      component_type: componentType,
      page_type: pageType,
      component_variant: componentVariant,
      url: window.location.href
    }
  };
};

// src/events/add-payment-info/add-payment-info.ts
var import_date_fns3 = require("date-fns");

// src/events/add-payment-info/add-payment-info.schema.ts
var import_zod4 = require("zod");

// src/shared/points-conversion/points-conversion.schema.ts
var import_zod = require("zod");
var PointsConversionSchema = import_zod.z.object({
  name: import_zod.z.string(),
  levels: import_zod.z.array(
    import_zod.z.object({
      min: import_zod.z.union([import_zod.z.custom(), import_zod.z.coerce.number(), import_zod.z.boolean()]).nullable(),
      max: import_zod.z.union([import_zod.z.custom(), import_zod.z.coerce.number(), import_zod.z.boolean()]).nullable(),
      rate: import_zod.z.union([import_zod.z.custom(), import_zod.z.coerce.number(), import_zod.z.string()]).nullable()
    })
  )
});

// src/shared/quote/quote.schema.ts
var import_zod3 = require("zod");

// src/validators.ts
var import_date_fns2 = require("date-fns");
var import_decimal7 = require("decimal.js");
var import_zod2 = require("zod");
var dateString = import_zod2.z.string().regex(/^\d{4}-\d{2}-\d{2}$/).or(import_zod2.z.date().transform((v) => (0, import_date_fns2.format)(v, "yyyy-MM-dd")));
var decimalPrice = import_zod2.z.union([import_zod2.z.string(), import_zod2.z.null(), import_zod2.z.any()]).transform((v) => {
  if (v === null) {
    return new import_decimal7.Decimal(0);
  }
  if (v instanceof import_decimal7.Decimal) {
    return v;
  }
  return new import_decimal7.Decimal(v);
});
var totalAmount = import_zod2.z.object({
  amount: decimalPrice,
  currency: import_zod2.z.string()
});

// src/shared/quote/quote.schema.ts
var QuoteSchema = import_zod3.z.object({
  offer: import_zod3.z.object({
    name: import_zod3.z.string(),
    charges: import_zod3.z.object({
      total: totalAmount,
      totalBeforeDiscount: totalAmount,
      payableAtBooking: import_zod3.z.object({
        discount: totalAmount
      }),
      payableAtProperty: import_zod3.z.object({
        total: totalAmount
      })
    }),
    promotion: import_zod3.z.object({
      name: import_zod3.z.string().nullish(),
      promotionCode: import_zod3.z.string().nullish()
    }).nullable(),
    pointsEarned: import_zod3.z.object({
      qffPoints: import_zod3.z.object({
        total: import_zod3.z.coerce.number()
      })
    }).nullish(),
    paidByDeposit: import_zod3.z.boolean().optional()
  }),
  property: import_zod3.z.object({
    id: import_zod3.z.string(),
    name: import_zod3.z.string(),
    category: import_zod3.z.string(),
    rating: import_zod3.z.coerce.number(),
    address: import_zod3.z.object({
      city: import_zod3.z.string().nullish(),
      state: import_zod3.z.string().nullish(),
      country: import_zod3.z.string().nullish()
    })
  }),
  roomType: import_zod3.z.object({
    name: import_zod3.z.string(),
    roomTypeFacilities: import_zod3.z.array(import_zod3.z.string())
  }),
  stay: import_zod3.z.object({
    checkIn: dateString,
    checkOut: dateString,
    adults: import_zod3.z.coerce.number(),
    children: import_zod3.z.coerce.number(),
    infants: import_zod3.z.coerce.number()
  })
});

// src/events/add-payment-info/add-payment-info.schema.ts
var addPaymentInfoEventSchema = import_zod4.z.object({
  quote: QuoteSchema,
  isRebooked: import_zod4.z.boolean(),
  payments: import_zod4.z.object({
    voucher: import_zod4.z.object({
      amount: decimalPrice,
      code: import_zod4.z.string().nullable()
    }),
    points: import_zod4.z.object({
      amount: decimalPrice,
      amountInCash: decimalPrice
    }),
    cash: import_zod4.z.object({
      payableNow: import_zod4.z.object({
        amount: decimalPrice
      })
    })
  }),
  pointsConversion: PointsConversionSchema
});

// src/events/add-payment-info/add-payment-info.ts
var addPaymentInfoEvent = (input) => {
  const { quote, payments, pointsConversion, isRebooked } = addPaymentInfoEventSchema.parse(input);
  const totalNights2 = (0, import_date_fns3.differenceInDays)(new Date(quote.stay.checkOut), new Date(quote.stay.checkIn));
  const dailyTotalAmount = quote.offer.charges.total.amount.dividedBy(totalNights2).toDecimalPlaces(2);
  const dailyPreDiscountAmount = quote.offer.charges.totalBeforeDiscount.amount.dividedBy(totalNights2).toDecimalPlaces(2);
  const isDepositPay = !!quote.offer.paidByDeposit;
  const isExclusive = !!quote.offer.promotion?.name?.toLowerCase().includes("exclusive");
  const isLuxury = !!quote.offer.promotion?.name?.toLowerCase().includes("luxury");
  const totalPointsValue = cashToPoints(quote.offer.charges.total.amount, pointsConversion);
  const pointsPayPercentage = payments.points.amount.greaterThan(0) ? payments.points.amount.dividedBy(totalPointsValue).times(100).toFixed(2) : 0;
  const { city, state, country } = quote.property.address;
  const location = `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country}`;
  return {
    event: "add_payment_info" /* ADD_PAYMENT_INFO */,
    event_data: {
      action: "add_payment" /* ADD_PAYMENT */,
      component_type: "checkout" /* CHECKOUT */
    },
    ecommerce: {
      value: quote.offer.charges.total.amount.toNumber(),
      payment_type: getPaymentType(
        {
          cash: quote.offer.charges.payableAtProperty.total.amount,
          creditCard: payments.cash.payableNow.amount,
          voucher: payments.voucher.amount,
          points: payments.points.amount
        },
        isDepositPay
      ),
      currency: quote.offer.charges.total.currency,
      items: [
        {
          item_id: quote.property.id,
          item_name: quote.property.name,
          item_category: quote.property.category,
          item_variant: quote.roomType.name,
          index: 0,
          quantity: totalNights2,
          price: dailyTotalAmount.toNumber(),
          original_price: dailyPreDiscountAmount.toNumber(),
          cash_used: payments.cash.payableNow.amount.toNumber(),
          points_used: payments.points.amount.toNumber(),
          points_value: totalPointsValue.toNumber(),
          has_offer: !!quote.offer.promotion,
          rating: quote.property.rating,
          luxe: isLuxury,
          start_date: quote.stay.checkIn,
          end_date: quote.stay.checkOut,
          travellers_adult: quote.stay.adults,
          travellers_children: quote.stay.children,
          travellers_infant: quote.stay.infants,
          number_of_nights: totalNights2,
          exclusive_offer: isExclusive,
          points_earned: quote.offer.pointsEarned?.qffPoints.total.toFixed(2) ?? 0,
          pay_in_points_percent: pointsPayPercentage,
          offer_type: quote.offer.promotion?.name,
          rebook: isRebooked,
          includes: quote.roomType.roomTypeFacilities.join(", "),
          payment_type: getPaymentType(
            {
              cash: quote.offer.charges.payableAtProperty.total.amount,
              creditCard: payments.cash.payableNow.amount,
              voucher: payments.voucher.amount,
              points: payments.points.amount
            },
            isDepositPay
          ),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International"
        }
      ]
    }
  };
};

// src/events/add-to-cart/add-to-cart.ts
var import_date_fns4 = require("date-fns");
var import_decimal8 = require("decimal.js");

// src/events/add-to-cart/add-to-cart.schema.ts
var import_zod5 = require("zod");
var addToCartEventSchema = import_zod5.z.object({
  property: import_zod5.z.object({
    id: import_zod5.z.string(),
    name: import_zod5.z.string(),
    category: import_zod5.z.string(),
    rating: import_zod5.z.coerce.number(),
    address: import_zod5.z.object({
      city: import_zod5.z.string().nullish(),
      state: import_zod5.z.string().nullish(),
      country: import_zod5.z.string().nullish()
    })
  }),
  roomType: import_zod5.z.object({
    name: import_zod5.z.string(),
    roomTypeFacilities: import_zod5.z.array(import_zod5.z.string())
  }),
  query: import_zod5.z.object({
    checkIn: dateString,
    checkOut: dateString,
    adults: import_zod5.z.coerce.number(),
    children: import_zod5.z.coerce.number(),
    infants: import_zod5.z.coerce.number()
  }),
  initialCash: decimalPrice,
  offer: import_zod5.z.object({
    name: import_zod5.z.string(),
    charges: import_zod5.z.object({
      total: totalAmount,
      totalCash: totalAmount.nullish(),
      totalBeforeDiscount: totalAmount
    }),
    promotion: import_zod5.z.object({
      name: import_zod5.z.string().nullish(),
      promotionCode: import_zod5.z.string().nullish()
    }).nullable(),
    pointsEarned: import_zod5.z.object({
      qffPoints: import_zod5.z.object({
        total: import_zod5.z.coerce.number()
      })
    }).nullish()
  }),
  pointsConversion: PointsConversionSchema,
  isRebooked: import_zod5.z.boolean()
});

// src/events/add-to-cart/add-to-cart.ts
var addToCartEvent = (input) => {
  const { property, roomType, offer, query, pointsConversion, initialCash, isRebooked } = addToCartEventSchema.parse(input);
  const totalNights2 = (0, import_date_fns4.differenceInDays)(new Date(query.checkOut), new Date(query.checkIn));
  const totalInCash = offer.charges.total.currency === "PTS" ? offer.charges.totalCash?.amount ?? new import_decimal8.Decimal(0) : offer.charges.total.amount;
  const totalCurrency = offer.charges.total.currency === "PTS" ? offer.charges.totalCash?.currency : offer.charges.total.currency;
  const totalInCashBeforeDiscount2 = offer.charges.totalBeforeDiscount.currency === "PTS" ? pointsToCash(offer.charges.totalBeforeDiscount.amount, pointsConversion) : offer.charges.totalBeforeDiscount.amount;
  const dailyTotalAmount = totalInCash.dividedBy(totalNights2).toDecimalPlaces(2);
  const dailyPreDiscountAmount = totalInCashBeforeDiscount2.dividedBy(totalNights2).toDecimalPlaces(2);
  const cashUsed = offer.charges.total.currency === "PTS" ? initialCash : offer.charges.total.amount;
  const pointsUsed = offer.charges.total.currency === "PTS" ? offer.charges.total.amount.minus(cashToPoints(initialCash, pointsConversion)) : new import_decimal8.Decimal(0);
  const pointsPayPercentage = pointsUsed.greaterThan(0) ? pointsUsed.dividedBy(offer.charges.total.amount).times(100).toFixed(2) : 0;
  const isExclusive = !!offer.promotion?.name?.toLowerCase().includes("exclusive");
  const isLuxury = !!offer.promotion?.name?.toLowerCase().includes("luxury");
  const { city, state, country } = property.address;
  const location = `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country}`;
  return {
    event: "add_to_cart" /* ADD_TO_CART */,
    event_data: {
      component_type: "cart" /* CART */,
      location: "Property Page" /* PROPERTY */
    },
    ecommerce: {
      value: totalInCash.toNumber(),
      currency: totalCurrency,
      items: [
        {
          item_id: property.id,
          item_name: property.name,
          item_category: property.category,
          item_variant: roomType.name,
          item_offer: offer.name,
          index: 0,
          quantity: totalNights2,
          price: dailyTotalAmount.toNumber(),
          original_price: dailyPreDiscountAmount.toNumber(),
          cash_used: cashUsed.toNumber(),
          points_used: pointsUsed.toNumber(),
          points_value: cashToPoints(totalInCash, pointsConversion).toNumber(),
          has_offer: !!offer.promotion,
          rating: property.rating,
          luxe: isLuxury,
          start_date: query.checkIn,
          end_date: query.checkOut,
          travellers_adult: query.adults,
          travellers_children: query.children,
          travellers_infant: query.infants,
          number_of_nights: totalNights2,
          number_of_rooms: 1,
          exclusive_offer: isExclusive,
          points_earned: offer.pointsEarned?.qffPoints.total ?? 0,
          pay_in_points_percentage: pointsPayPercentage,
          offer_type: offer.promotion?.name,
          rebook: isRebooked,
          includes: roomType.roomTypeFacilities.join(", "),
          payment_type: getPaymentType({
            cash: cashUsed,
            points: pointsUsed
          }),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International"
        }
      ]
    }
  };
};

// src/events/begin-checkout/begin-checkout.ts
var import_date_fns5 = require("date-fns");

// src/events/begin-checkout/begin-checkout.schema.ts
var import_zod6 = require("zod");
var beginCheckoutEventSchema = import_zod6.z.object({
  quote: QuoteSchema,
  isRebooked: import_zod6.z.boolean(),
  payments: import_zod6.z.object({
    voucher: import_zod6.z.object({
      amount: decimalPrice,
      code: import_zod6.z.string().nullable()
    }),
    points: import_zod6.z.object({
      amount: decimalPrice,
      amountInCash: decimalPrice
    }),
    cash: import_zod6.z.object({
      payableNow: import_zod6.z.object({
        amount: decimalPrice
      })
    })
  }),
  pointsConversion: PointsConversionSchema
});

// src/events/begin-checkout/begin-checkout.ts
var beginCheckoutEvent = (input) => {
  const { quote, payments, pointsConversion, isRebooked } = beginCheckoutEventSchema.parse(input);
  const totalNights2 = (0, import_date_fns5.differenceInDays)(new Date(quote.stay.checkOut), new Date(quote.stay.checkIn));
  const dailyTotalAmount = quote.offer.charges.total.amount.dividedBy(totalNights2).toDecimalPlaces(2);
  const dailyPreDiscountAmount = quote.offer.charges.totalBeforeDiscount.amount.dividedBy(totalNights2).toDecimalPlaces(2);
  const isExclusive = !!quote.offer.promotion?.name?.toLowerCase().includes("exclusive");
  const isLuxury = !!quote.offer.promotion?.name?.toLowerCase().includes("luxury");
  const totalPointsValue = cashToPoints(quote.offer.charges.total.amount, pointsConversion);
  const pointsPayPercentage = payments.points.amount.greaterThan(0) ? payments.points.amount.dividedBy(totalPointsValue).times(100).toFixed(2) : 0;
  const { city, state, country } = quote.property.address;
  const location = `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country}`;
  return {
    event: "begin_checkout" /* BEGIN_CHECKOUT */,
    event_data: {
      action: "start" /* START */,
      component_type: "checkout" /* CHECKOUT */
    },
    ecommerce: {
      value: quote.offer.charges.total.amount.toNumber(),
      currency: quote.offer.charges.total.currency,
      items: [
        {
          item_id: quote.property.id,
          item_name: quote.property.name,
          item_category: quote.property.category,
          item_variant: quote.roomType.name,
          index: 0,
          quantity: totalNights2,
          price: dailyTotalAmount.toNumber(),
          original_price: dailyPreDiscountAmount.toNumber(),
          cash_used: payments.cash.payableNow.amount.toNumber(),
          points_used: payments.points.amount.toNumber(),
          points_value: totalPointsValue.toNumber(),
          has_offer: !!quote.offer.promotion,
          rating: quote.property.rating,
          luxe: isLuxury,
          start_date: quote.stay.checkIn,
          end_date: quote.stay.checkOut,
          travellers_adult: quote.stay.adults,
          travellers_children: quote.stay.children,
          travellers_infant: quote.stay.infants,
          number_of_nights: totalNights2,
          exclusive_offer: isExclusive,
          // FIXME:
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          points_earned: quote.offer?.pointsEarned?.qffPoints.total.toFixed(2) ?? 0,
          pay_in_points_percent: pointsPayPercentage,
          offer_type: quote.offer.promotion?.name,
          rebook: isRebooked,
          includes: quote.roomType.roomTypeFacilities.join(", "),
          payment_type: getPaymentType({
            cash: quote.offer.charges.payableAtProperty.total.amount,
            creditCard: payments.cash.payableNow.amount,
            voucher: payments.voucher.amount,
            points: payments.points.amount
          }),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International"
        }
      ]
    }
  };
};

// src/events/checkout-error/checkout-error.schema.ts
var import_zod7 = require("zod");
var checkoutErrorEventSchema = import_zod7.z.object({
  errors: import_zod7.z.array(
    import_zod7.z.object({
      code: import_zod7.z.string(),
      message: import_zod7.z.string().nullish()
    })
  )
});

// src/events/checkout-error/checkout-error.ts
var checkoutErrorEvent = (input) => {
  const { errors } = checkoutErrorEventSchema.parse(input);
  return {
    event: "checkout_error" /* CHECKOUT_ERROR */,
    event_data: {
      action: "error" /* ERROR */,
      component_type: "checkout" /* CHECKOUT */,
      errors: errors.map((error) => ({
        id: error.code,
        message: error.message
      }))
    }
  };
};

// src/events/cta-click/cta-click.schema.ts
var import_zod8 = require("zod");
var ctaClickEventSchema = import_zod8.z.object({
  label: import_zod8.z.string(),
  pageType: import_zod8.z.string().optional(),
  url: import_zod8.z.string().url(),
  variant: import_zod8.z.string()
});

// src/events/cta-click/cta-click.ts
var ctaClickEvent = (input) => {
  const { label, pageType, url, variant } = ctaClickEventSchema.parse(input);
  return {
    event: "cta_click" /* CTA_CLICK */,
    payload: {
      action: "click" /* CLICK */,
      component_type: "cta" /* CTA */,
      component_variant: variant,
      item_text: label,
      item_type: "button" /* BUTTON */,
      page_type: pageType,
      url
    }
  };
};

// src/events/custom-click/custom-click.schema.ts
var import_zod9 = require("zod");
var customClickEventSchema = import_zod9.z.object({
  itemText: import_zod9.z.string(),
  variant: import_zod9.z.string()
});

// src/events/custom-click/custom-click.ts
var customClickEvent = (input) => {
  const { itemText, variant } = customClickEventSchema.parse(input);
  return {
    event: "custom_click" /* CUSTOM_CLICK */,
    payload: {
      action: "click" /* CLICK */,
      component_type: "custom" /* CUSTOM */,
      component_variant: variant,
      item_text: itemText,
      item_type: "button" /* BUTTON */
    }
  };
};

// src/events/filter-update/filter-update.schema.ts
var import_zod10 = require("zod");
var filterUpdateEventSchema = import_zod10.z.object({
  groupName: import_zod10.z.enum([
    "Price per night",
    "Popular Filters",
    "Hotel Rating",
    "Tripadvisor Rating",
    "Property Type",
    "Facilities",
    "Area",
    "Deal Type Filters"
  ]),
  itemName: import_zod10.z.enum([
    "price range",
    "popular filters",
    "hotel rating",
    "tripadvisor rating",
    "property type",
    "facility",
    "area",
    "deal type"
  ]),
  itemText: import_zod10.z.union([
    import_zod10.z.string(),
    import_zod10.z.object({
      maxPrice: import_zod10.z.string().nullable(),
      minPrice: import_zod10.z.string().nullable()
    })
  ]),
  itemType: import_zod10.z.enum(["radio", "value"]),
  itemValue: import_zod10.z.union([
    import_zod10.z.string(),
    import_zod10.z.object({
      maxPrice: import_zod10.z.string().nullable(),
      minPrice: import_zod10.z.string().nullable()
    })
  ])
});

// src/events/filter-update/filter-update.ts
var filterUpdateEvent = (input) => {
  const { groupName, itemName, itemText, itemType, itemValue } = filterUpdateEventSchema.parse(input);
  return {
    event: "filter_update" /* FILTER_UPDATE */,
    event_data: {
      action: "update" /* UPDATE */,
      component_type: "filter" /* FILTER */,
      group_name: groupName,
      item_name: itemName,
      item_text: itemText,
      item_type: itemType,
      item_value: itemValue
    }
  };
};

// src/shared/user/user.ts
var user = (props) => {
  const { userId, qffHashId, isLoggedIn, qffPoints } = UserSchema.parse(props);
  return {
    user_id: userId,
    user_qff_hash: qffHashId,
    user_login_status: isLoggedIn ? "logged in" /* LOGGED_IN */ : "logged out" /* LOGGED_OUT */,
    user_points: qffPoints
  };
};

// src/shared/user/user.schema.ts
var import_zod11 = require("zod");
var UserSchema = import_zod11.z.object({
  userId: import_zod11.z.string(),
  qffHashId: import_zod11.z.string().nullish(),
  isLoggedIn: import_zod11.z.boolean().default(false),
  qffPoints: import_zod11.z.coerce.number().nullish(),
  qffTier: import_zod11.z.string().nullish()
});

// src/events/login/login.schema.ts
var loginEventSchema = UserSchema;

// src/events/login/login.ts
var loginEvent = (input) => {
  const { userId, qffPoints, qffTier } = loginEventSchema.parse(input);
  return {
    event: "login" /* LOGIN */,
    event_data: {
      action: "login" /* LOGIN */
    },
    user: user({ userId, isLoggedIn: true, qffPoints, qffTier })
  };
};

// src/events/logout/logout.ts
var logoutEvent = () => ({
  event: "logout" /* LOGOUT */,
  event_data: {
    action: "logout" /* LOGOUT */
  }
});

// src/events/menu-click/menu-click.schema.ts
var import_zod12 = require("zod");
var menuClickEventSchema = import_zod12.z.object({
  itemText: import_zod12.z.string(),
  url: import_zod12.z.string().url()
});

// src/events/menu-click/menu-click.ts
var menuClickEvent = (input) => {
  const { itemText, url } = menuClickEventSchema.parse(input);
  return {
    event: "menu_click" /* MENU_CLICK */,
    event_data: {
      action: "click" /* CLICK */,
      component_type: "menu" /* MENU */,
      item_text: itemText,
      url
    }
  };
};

// src/events/page-view/page-view.schema.ts
var import_zod13 = require("zod");
var PageViewSchema = import_zod13.z.object({
  type: import_zod13.z.nativeEnum(PageType),
  title: import_zod13.z.string(),
  location: import_zod13.z.string(),
  referrer: import_zod13.z.string().optional(),
  siteId: import_zod13.z.nativeEnum(SiteId),
  siteVertical: import_zod13.z.nativeEnum(SiteVertical).default("travel" /* TRAVEL */)
}).merge(UserSchema);

// src/events/page-view/page-view.ts
var pageViewEvent = (props) => {
  const {
    userId,
    qffHashId,
    isLoggedIn,
    qffPoints,
    qffTier,
    type,
    title,
    location,
    referrer,
    siteId = "hotels",
    siteVertical = "travel"
  } = PageViewSchema.parse(props);
  return {
    event: "page_view" /* PAGE_VIEW */,
    event_data: {
      action: "view" /* VIEW */
    },
    site: {
      site_id: siteId,
      site_vertical: siteVertical
    },
    content: {
      page_location: location,
      page_referrer: referrer,
      page_type: type,
      page_title: title
    },
    user: user({ userId, qffHashId, isLoggedIn, qffPoints, qffTier })
  };
};

// src/events/promotion-code-apply/promotion-code-apply.schema.ts
var import_zod14 = require("zod");
var promotionCodeApplySchema = import_zod14.z.object({
  code: import_zod14.z.string(),
  status: import_zod14.z.string()
});

// src/events/promotion-code-apply/promotion-code-apply.ts
var promotionCodeApplyEvent = (input) => {
  const { code, status } = promotionCodeApplySchema.parse(input);
  return {
    event: "promotion_code_apply" /* PROMOTION_CODE_APPLY */,
    event_data: {
      action: "apply" /* APPLY */,
      component_type: "promotion_code" /* PROMOTION_CODE */,
      code,
      status
    }
  };
};

// src/events/purchase/purchase.ts
var import_date_fns6 = require("date-fns");

// src/utils/payment-totals.ts
var getPaymentTotals = (bookingTotal, bookingCharges, quoteCharges) => {
  const voucher = bookingTotal.voucher.total ?? 0;
  const creditCard = bookingTotal.creditCard.total ?? 0;
  const creditNote = bookingTotal.creditNote.total ?? 0;
  const qantasGroupCreditVoucher = bookingTotal.qantasGroupCreditVoucher.total ?? 0;
  const points = bookingTotal.points.totalPoints ?? 0;
  const totalAmount2 = bookingCharges.payableAtBooking.total.amount;
  const discountAmount = quoteCharges.payableAtBooking.discount.amount;
  const preDiscountTotal = quoteCharges.totalBeforeDiscount.amount;
  return {
    methods: {
      creditCard,
      creditNote,
      points,
      qantasGroupCreditVoucher,
      voucher
    },
    totalAmount: totalAmount2,
    discountAmount,
    preDiscountTotal
  };
};

// src/events/purchase/purchase.schema.ts
var import_zod16 = require("zod");

// src/shared/booking/booking.schema.ts
var import_zod15 = require("zod");
var BookingSchema = import_zod15.z.object({
  id: import_zod15.z.string(),
  bookingTotal: import_zod15.z.object({
    creditCard: import_zod15.z.object({
      total: decimalPrice
    }),
    points: import_zod15.z.object({
      totalPoints: decimalPrice
    }),
    voucher: import_zod15.z.object({
      total: decimalPrice
    }),
    creditNote: import_zod15.z.object({
      total: decimalPrice
    }),
    qantasGroupCreditVoucher: import_zod15.z.object({
      total: decimalPrice
    })
  }),
  value: totalAmount,
  reservation: import_zod15.z.object({
    checkIn: dateString,
    checkOut: dateString,
    adults: import_zod15.z.coerce.number(),
    children: import_zod15.z.coerce.number(),
    infants: import_zod15.z.coerce.number(),
    property: import_zod15.z.object({
      id: import_zod15.z.string(),
      name: import_zod15.z.string(),
      category: import_zod15.z.string(),
      rating: import_zod15.z.any().pipe(import_zod15.z.coerce.number()),
      address: import_zod15.z.object({
        city: import_zod15.z.string().nullish(),
        state: import_zod15.z.string().nullish(),
        country: import_zod15.z.string().nullish()
      })
    }),
    offer: import_zod15.z.object({
      name: import_zod15.z.string(),
      charges: import_zod15.z.object({
        payableAtProperty: import_zod15.z.object({
          total: totalAmount
        }),
        payableAtBooking: import_zod15.z.object({
          tax: totalAmount,
          taxDisplayable: totalAmount,
          total: totalAmount
        }),
        total: totalAmount
      }),
      promotion: import_zod15.z.object({
        name: import_zod15.z.string().nullish(),
        promotionCode: import_zod15.z.string().nullish()
      }).nullable(),
      pointsEarned: import_zod15.z.object({
        qffPoints: import_zod15.z.object({
          total: import_zod15.z.coerce.number()
        })
      }).nullish(),
      pointsTierInstance: PointsConversionSchema
    }),
    roomType: import_zod15.z.object({
      name: import_zod15.z.string(),
      roomTypeFacilities: import_zod15.z.array(import_zod15.z.string())
    })
  })
});

// src/events/purchase/purchase.schema.ts
var purchaseEventSchema = import_zod16.z.object({
  booking: BookingSchema,
  quote: QuoteSchema,
  isRebooked: import_zod16.z.boolean()
});

// src/events/purchase/purchase.ts
var purchaseEvent = (input) => {
  const { isRebooked, booking, quote } = purchaseEventSchema.parse(input);
  const { methods, totalAmount: totalAmount2, preDiscountTotal, discountAmount } = getPaymentTotals(
    booking.bookingTotal,
    booking.reservation.offer.charges,
    quote.offer.charges
  );
  const { pointsPayPercentage } = getPointsTotals(totalAmount2, methods);
  const isDepositPay = !!quote.offer.paidByDeposit;
  const depositPayPercentage = isDepositPay ? methods.creditCard.dividedBy(totalAmount2).times(100).round().toNumber() : 0;
  const totalNights2 = (0, import_date_fns6.differenceInDays)(
    new Date(booking.reservation.checkOut),
    new Date(booking.reservation.checkIn)
  );
  const dailyTotalAmount = totalAmount2.dividedBy(totalNights2).toDecimalPlaces(2);
  const dailyPreDiscountAmount = preDiscountTotal.dividedBy(totalNights2).toDecimalPlaces(2);
  const isExclusive = !!booking.reservation.offer.promotion?.name?.toLowerCase().includes("exclusive");
  const isLuxury = !!booking.reservation.offer.promotion?.name?.toLowerCase().includes("luxury");
  const { city, state, country } = booking.reservation.property.address;
  const location = `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country}`;
  return {
    event: "purchase" /* PURCHASE */,
    event_data: {
      action: "purchase" /* PURCHASE */,
      component_type: "checkout" /* CHECKOUT */
    },
    ecommerce: {
      transaction_id: booking.id,
      value: totalAmount2.toNumber(),
      tax: booking.reservation.offer.charges.payableAtBooking.taxDisplayable.amount.toNumber(),
      shipping: 0,
      payment_type: getPaymentType(methods, isDepositPay),
      deposit_pay_percentage: depositPayPercentage,
      total_cash_used: methods.creditCard.toNumber(),
      total_points_earned: booking.reservation.offer.pointsEarned?.qffPoints.total ?? 0,
      total_points_used_percentage: pointsPayPercentage,
      total_points_used: methods.points.toNumber(),
      total_points_value: booking.value.currency === "PTS" ? booking.value.amount.toNumber() : cashToPoints(totalAmount2, booking.reservation.offer.pointsTierInstance).toNumber(),
      voucher_value: methods.voucher.toNumber(),
      discount_value: discountAmount.toNumber(),
      coupon: booking.reservation.offer.promotion?.promotionCode,
      voucher_used: !!methods.voucher.toNumber(),
      currency: booking.reservation.offer.charges.total.currency,
      items: [
        {
          item_id: booking.reservation.property.id,
          item_name: booking.reservation.property.name,
          item_category: booking.reservation.property.category,
          item_variant: booking.reservation.roomType.name,
          item_offer: booking.reservation.offer.name,
          index: 0,
          price: dailyTotalAmount.toNumber(),
          original_price: dailyPreDiscountAmount.toNumber(),
          cash_used: methods.creditCard.toNumber(),
          points_used: methods.points.toNumber(),
          has_offer: !!booking.reservation.offer.promotion,
          rating: booking.reservation.property.rating,
          luxe: isLuxury,
          start_date: booking.reservation.checkIn,
          end_date: booking.reservation.checkOut,
          travellers_adult: booking.reservation.adults,
          travellers_children: booking.reservation.children,
          travellers_infant: booking.reservation.infants,
          number_of_nights: totalNights2,
          number_of_rooms: 1,
          exclusive_offer: isExclusive,
          points_earned: booking.reservation.offer.pointsEarned?.qffPoints.total ?? 0,
          pay_in_points_percentage: pointsPayPercentage,
          offer_type: booking.reservation.offer.promotion?.name,
          rebook: isRebooked,
          includes: booking.reservation.roomType.roomTypeFacilities.join(", "),
          payment_type: getPaymentType(methods, isDepositPay),
          location,
          international_or_domestic: country === "Australia" ? "Domestic" : "International"
        }
      ]
    }
  };
};

// src/events/search-exit-field/search-exit-field.schema.ts
var import_zod17 = require("zod");
var searchExitFieldEventSchema = import_zod17.z.object({
  variant: import_zod17.z.string(),
  itemName: import_zod17.z.string(),
  itemType: import_zod17.z.string().nullable(),
  itemValue: import_zod17.z.string().nullable()
});

// src/events/search-exit-field/search-exit-field.ts
var searchExitFieldEvent = (input) => {
  const { variant, itemName, itemType, itemValue } = searchExitFieldEventSchema.parse(input);
  return {
    event: "search_exit_field" /* SEARCH_EXIT_FIELD */,
    event_data: {
      action: "exit_field" /* EXIT_FIELD */,
      component_type: "search" /* SEARCH */,
      component_variant: variant,
      item_name: itemName,
      item_type: itemType,
      item_value: itemValue
    }
  };
};

// src/events/search-submit/search-submit.schema.ts
var import_zod18 = require("zod");
var searchSubmitEventSchema = import_zod18.z.object({
  componentVariant: import_zod18.z.enum(["activities search"]),
  searchTerm: import_zod18.z.string(),
  startDate: import_zod18.z.string().optional(),
  endDate: import_zod18.z.string().optional()
});

// src/events/search-submit/search-submit.ts
var searchSubmitEvent = (input) => {
  const { componentVariant, searchTerm, startDate, endDate } = searchSubmitEventSchema.parse(input);
  return {
    event: "search_submit" /* SEARCH_SUBMIT */,
    payload: {
      action: "submit" /* SUBMIT */,
      component_type: "search" /* SEARCH */,
      component_variant: componentVariant,
      search_term: searchTerm,
      start_date: startDate,
      end_date: endDate
    }
  };
};

// src/events/search-suggestion-click/search-suggestion-click.schema.ts
var import_zod19 = require("zod");
var searchSuggestionClickEventSchema = import_zod19.z.object({
  componentVariant: import_zod19.z.enum(["destination", "property"]),
  itemId: import_zod19.z.string().nullable(),
  itemName: import_zod19.z.string().nullable(),
  itemText: import_zod19.z.string(),
  index: import_zod19.z.number(),
  url: import_zod19.z.string(),
  count: import_zod19.z.number(),
  searchRecent: import_zod19.z.array(import_zod19.z.string()),
  viewMode: import_zod19.z.enum(["list", "tile"])
});

// src/events/search-suggestion-click/search-suggestion-click.ts
var searchSuggestionClickEvent = (input) => {
  const {
    componentVariant,
    itemId,
    itemName,
    itemText,
    index,
    url,
    count,
    searchRecent,
    viewMode
  } = searchSuggestionClickEventSchema.parse(input);
  return {
    event: "search_suggestion_click" /* SEARCH_SUGGESTION_CLICK */,
    event_data: {
      action: "click" /* CLICK */,
      component_type: "search" /* SEARCH */,
      group_name: "recent search",
      component_variant: componentVariant,
      item_id: itemId,
      item_name: itemName,
      item_text: itemText,
      index,
      url,
      count,
      search_recent: searchRecent,
      view_mode: viewMode
    }
  };
};

// src/events/search-suggestion-display/search-suggestion-display.schema.ts
var import_zod20 = require("zod");
var searchSuggestionDisplayEventSchema = import_zod20.z.object({
  componentVariant: import_zod20.z.enum(["destinations", "properties", "destinations and properties"]),
  count: import_zod20.z.number().nullable(),
  searchRecent: import_zod20.z.array(import_zod20.z.string()),
  viewMode: import_zod20.z.enum(["list", "tile"])
});

// src/events/search-suggestion-display/search-suggestion-display.ts
var searchSuggestionDisplayEvent = (input) => {
  const { count, searchRecent, viewMode, componentVariant } = searchSuggestionDisplayEventSchema.parse(input);
  return {
    event: "search_suggestion_display" /* SEARCH_SUGGESTION_DISPLAY */,
    event_data: {
      action: "display" /* DISPLAY */,
      component_type: "search" /* SEARCH */,
      component_variant: componentVariant,
      group_name: "recent search",
      count,
      search_recent: searchRecent,
      view_mode: viewMode
    }
  };
};

// src/events/select-item/select-item.ts
var import_date_fns7 = require("date-fns");
var import_decimal9 = require("decimal.js");

// src/events/select-item/select-item.schema.ts
var import_zod21 = require("zod");
var selectItemEventSchema = import_zod21.z.object({
  listName: import_zod21.z.string(),
  location: import_zod21.z.string(),
  type: import_zod21.z.enum(["list", "map"]),
  category: import_zod21.z.enum(["qantas", "jetstar", "airbnb"]),
  payWith: import_zod21.z.enum(["cash", "points", "cash and points"]),
  availableProperties: import_zod21.z.number().nullish(),
  availableRooms: import_zod21.z.number().nullish(),
  property: import_zod21.z.object({
    id: import_zod21.z.string(),
    name: import_zod21.z.string(),
    category: import_zod21.z.string(),
    propertyFacilities: import_zod21.z.array(import_zod21.z.string())
  }),
  roomType: import_zod21.z.object({
    name: import_zod21.z.string().nullable()
  }).nullish(),
  query: import_zod21.z.object({
    checkIn: dateString.nullish(),
    checkOut: dateString.nullish(),
    adults: import_zod21.z.coerce.number(),
    children: import_zod21.z.coerce.number(),
    infants: import_zod21.z.coerce.number()
  }).nullish(),
  offer: import_zod21.z.object({
    name: import_zod21.z.string(),
    charges: import_zod21.z.object({
      total: totalAmount,
      totalCash: totalAmount.nullish()
    }),
    promotion: import_zod21.z.object({
      name: import_zod21.z.string().nullish(),
      promotionCode: import_zod21.z.string().nullish()
    }).nullable(),
    depositPay: import_zod21.z.object({
      depositPayable: import_zod21.z.boolean()
    })
  }),
  pointsConversion: PointsConversionSchema
}).transform((val) => ({
  ...val,
  id: val.listName.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_")
}));

// src/events/select-item/select-item.ts
var selectItemEvent = (input) => {
  const {
    id,
    listName,
    location,
    type,
    category,
    payWith,
    availableProperties,
    availableRooms,
    query,
    property,
    roomType,
    offer,
    pointsConversion
  } = selectItemEventSchema.parse(input);
  const numberOfNights = query?.checkIn && query?.checkOut ? (0, import_date_fns7.differenceInDays)(new Date(query.checkOut), new Date(query.checkIn)) : void 0;
  const totalPointsValue = (
    // FIXME:
    // eslint-disable-next-line no-nested-ternary
    payWith === "cash" || payWith === "cash and points" ? cashToPoints(offer?.charges?.total?.amount, pointsConversion).toNumber() : payWith === "points" && offer?.charges?.totalCash?.amount.toNumber() === 0 ? cashToPoints(offer?.charges?.total?.amount, pointsConversion).toNumber() : cashToPoints(
      offer?.charges?.totalCash?.amount ?? new import_decimal9.Decimal(0),
      pointsConversion
    ).toNumber()
  );
  return {
    event: "select_item" /* SELECT_ITEM */,
    event_data: {
      action: "click" /* CLICK */,
      component_type: "item_list" /* ITEM_LIST */,
      search_term: location,
      search_type: type,
      search_category: category,
      search_payment_toggle: payWith,
      ...availableProperties && {
        available_property_count: availableProperties
      },
      ...availableRooms && {
        available_room_count: availableRooms
      },
      ...query?.checkIn && {
        start_date: query.checkIn
      },
      ...query?.checkOut && { end_date: query.checkOut },
      ...query?.adults && { travellers_adult: query.adults },
      ...query?.children && { travellers_children: query.children },
      ...query?.infants && { travellers_infant: query.infants }
    },
    ecommerce: {
      currency: offer.charges.totalCash?.currency ?? offer.charges.total.currency,
      item_list_id: id,
      item_list_name: listName,
      items: [
        {
          item_id: property.id,
          item_name: property.name,
          item_category: property.category,
          ...roomType?.name && { item_variant: roomType.name },
          index: 0,
          quantity: numberOfNights,
          price: (
            // FIXME:
            // eslint-disable-next-line no-nested-ternary
            payWith === "cash" || payWith === "cash and points" ? offer?.charges?.total?.amount.toNumber() : payWith === "points" && offer?.charges?.totalCash?.amount.toNumber() === 0 ? offer?.charges?.total?.amount.toNumber() : offer?.charges?.totalCash?.amount.toNumber()
          ),
          points_value: totalPointsValue,
          has_offer: !!offer.promotion,
          has_deposit_pay: offer.depositPay.depositPayable
        }
      ]
    }
  };
};

// src/events/select-holidays-item/select-holidays-item.ts
var import_date_fns8 = require("date-fns");

// src/events/select-holidays-item/select-holidays-item.schema.ts
var import_zod22 = require("zod");
var selectHolidaysItemEventSchema = import_zod22.z.object({
  type: import_zod22.z.enum(["list", "map"]),
  brand: import_zod22.z.enum(["qantas", "jetstar"]),
  availableProperties: import_zod22.z.number(),
  index: import_zod22.z.number(),
  propertyId: import_zod22.z.string(),
  propertyName: import_zod22.z.string(),
  roomType: import_zod22.z.string(),
  value: import_zod22.z.number(),
  pointValue: import_zod22.z.number().nullable(),
  hasOffer: import_zod22.z.boolean(),
  query: import_zod22.z.object({
    destination: import_zod22.z.string(),
    origin: import_zod22.z.string(),
    departureDate: dateString,
    returnDate: dateString,
    adults: import_zod22.z.coerce.number(),
    children: import_zod22.z.coerce.number(),
    infants: import_zod22.z.coerce.number()
  })
});

// src/events/select-holidays-item/select-holidays-item.ts
var selectHolidaysItemEvent = (input) => {
  const {
    type,
    brand,
    availableProperties,
    propertyId,
    propertyName,
    roomType,
    value,
    hasOffer,
    query,
    pointValue,
    index
  } = selectHolidaysItemEventSchema.parse(input);
  const { departureDate, returnDate, destination, origin, adults, children, infants } = query;
  const numberOfNights = (0, import_date_fns8.differenceInDays)(
    new Date(query.returnDate),
    new Date(query.departureDate)
  );
  return {
    event: "select_item" /* SELECT_ITEM */,
    event_data: {
      action: "click" /* CLICK */,
      component_type: "item_list" /* ITEM_LIST */,
      page_type: "search",
      search_term: destination,
      destination,
      origin,
      search_type: type,
      search_category: brand,
      available_property_count: availableProperties,
      start_date: departureDate,
      end_date: returnDate,
      travellers_adult: adults,
      travellers_children: children,
      travellers_infant: infants
    },
    ecommerce: {
      currency: "AUD",
      value,
      items: [
        {
          item_id: propertyId,
          item_name: propertyName,
          item_variant: roomType,
          item_category: `Holiday package to ${destination}`,
          index,
          quantity: numberOfNights,
          price: value / numberOfNights,
          points_value: pointValue ? pointValue / numberOfNights : null,
          has_offer: hasOffer
        }
      ]
    }
  };
};

// src/events/select-promotion/select-promotion.schema.ts
var import_zod23 = require("zod");
var selectPromotionSchema = import_zod23.z.object({
  promotion: import_zod23.z.object({
    name: import_zod23.z.string(),
    slot: import_zod23.z.string(),
    assetName: import_zod23.z.string().nullish()
  }).transform((val) => ({
    ...val,
    id: val.name.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_")
  }))
});

// src/events/select-promotion/select-promotion.ts
var selectPromotionEvent = (input) => {
  const { promotion } = selectPromotionSchema.parse(input);
  return {
    event: "select_promotion" /* SELECT_PROMOTION */,
    event_data: {
      action: "click" /* CLICK */,
      component_type: "promotion_list" /* PROMOTION_LIST */,
      items: [
        {
          promotion_id: promotion.id,
          promotion_name: promotion.name,
          creative_name: promotion.assetName,
          creative_slot: promotion.slot
        }
      ]
    }
  };
};

// src/events/tab-click/tab-click.schema.ts
var import_zod24 = require("zod");
var tabClickEventSchema = import_zod24.z.object({
  itemName: import_zod24.z.string(),
  itemText: import_zod24.z.string(),
  pageType: import_zod24.z.string(),
  tabIndex: import_zod24.z.number(),
  variant: import_zod24.z.string()
});

// src/events/tab-click/tab-click.ts
var tabClickEvent = (input) => {
  const { itemName, itemText, pageType, tabIndex, variant } = tabClickEventSchema.parse(input);
  return {
    event: "tab_click" /* TAB_CLICK */,
    payload: {
      action: "click" /* CLICK */,
      component_type: "tab" /* TAB */,
      component_variant: variant,
      index: tabIndex,
      item_name: itemName,
      item_text: itemText,
      page_type: pageType
    }
  };
};

// src/events/view-item/view-item.ts
var import_date_fns9 = require("date-fns");

// src/events/view-item/view-item.schema.ts
var import_zod25 = require("zod");
var viewItemEventPropertySchema = import_zod25.z.object({
  id: import_zod25.z.string(),
  name: import_zod25.z.string(),
  category: import_zod25.z.string(),
  facilities: import_zod25.z.string(),
  imageCount: import_zod25.z.number(),
  rating: import_zod25.z.number(),
  internationalOrDomestic: import_zod25.z.string()
});
var viewItemEventSchema = import_zod25.z.object({
  averagePrice: import_zod25.z.number(),
  currency: import_zod25.z.string(),
  averagePriceBeforeDiscount: import_zod25.z.number(),
  averagePricePoints: import_zod25.z.number().nullish(),
  averagePointsEarned: import_zod25.z.number().nullish(),
  recommendedProperty: import_zod25.z.boolean(),
  luxuryOffer: import_zod25.z.boolean(),
  checkIn: dateString.nullish(),
  checkOut: dateString.nullish(),
  adults: import_zod25.z.coerce.number().nullish(),
  children: import_zod25.z.coerce.number().nullish(),
  infants: import_zod25.z.coerce.number().nullish(),
  availableOffers: import_zod25.z.number().nullish(),
  availableRooms: import_zod25.z.number().nullish(),
  rebook: import_zod25.z.boolean(),
  payWith: import_zod25.z.enum(["cash", "points", "cash and points"]),
  location: import_zod25.z.string(),
  nights: import_zod25.z.number().nullish(),
  results: import_zod25.z.object({
    property: viewItemEventPropertySchema
  })
});

// src/events/view-item/view-item.ts
var viewItemEvent = (input) => {
  const {
    currency,
    results,
    checkIn,
    checkOut,
    averagePrice,
    averagePricePoints,
    averagePriceBeforeDiscount,
    averagePointsEarned,
    recommendedProperty,
    luxuryOffer,
    adults,
    children,
    infants,
    availableOffers,
    availableRooms,
    rebook,
    payWith,
    location,
    nights
  } = viewItemEventSchema.parse(input);
  const numberOfNights = checkIn && checkOut ? (0, import_date_fns9.differenceInDays)(new Date(checkOut), new Date(checkIn)) : nights;
  return {
    event: "view_item" /* VIEW_ITEM */,
    event_data: {
      action: "view" /* VIEW */,
      component_type: "item" /* ITEM */
    },
    ecommerce: {
      value: averagePrice,
      currency,
      items: [
        {
          item_id: results.property.id,
          item_name: results.property.name,
          item_category: results.property.category,
          item_brand: void 0,
          item_variant: void 0,
          item_offer: void 0,
          index: 0,
          quantity: 1,
          price: averagePrice,
          original_price: averagePriceBeforeDiscount,
          cash_used: void 0,
          points_used: void 0,
          points_value: averagePricePoints,
          recommend: recommendedProperty,
          rating: results.property.rating,
          luxe: luxuryOffer,
          image_count: results.property.imageCount,
          start_date: checkIn,
          end_date: checkOut,
          travellers_adult: adults,
          travellers_children: children,
          travellers_infant: infants,
          number_of_nights: numberOfNights,
          number_of_rooms: 1,
          available_offer_count: availableOffers,
          available_room_count: availableRooms,
          points_earned: averagePointsEarned,
          pay_in_points_percentage: void 0,
          offer_type: void 0,
          rebook,
          includes: results.property.facilities,
          payment_type: payWith,
          location,
          international_or_domestic: results.property.internationalOrDomestic
        }
      ]
    }
  };
};

// src/events/view-item-list/view-item-list.ts
var import_date_fns10 = require("date-fns");

// src/events/view-item-list/view-item-list.schema.ts
var import_zod26 = require("zod");
var viewItemListEventOfferSchema = import_zod26.z.object({
  charges: import_zod26.z.object({
    totalCash: import_zod26.z.object({
      amount: decimalPrice
    }),
    total: import_zod26.z.object({
      amount: decimalPrice
    })
  })
});
var viewItemListEventRoomTypeSchema = import_zod26.z.object({
  name: import_zod26.z.string()
});
var viewItemListEventPropertySchema = import_zod26.z.object({
  id: import_zod26.z.string().nullish(),
  name: import_zod26.z.string().nullish(),
  hasOffer: import_zod26.z.boolean(),
  category: import_zod26.z.string().nullish()
});
var viewItemListEventSchema = import_zod26.z.object({
  listName: import_zod26.z.string(),
  location: import_zod26.z.string(),
  currency: import_zod26.z.string(),
  type: import_zod26.z.enum(["list", "map"]),
  category: import_zod26.z.enum(["qantas", "jetstar", "airbnb"]),
  payWith: import_zod26.z.enum(["cash", "points", "cash and points"]),
  availableProperties: import_zod26.z.number().nullish(),
  availableRooms: import_zod26.z.number().nullish(),
  checkIn: dateString.nullish(),
  checkOut: dateString.nullish(),
  adults: import_zod26.z.coerce.number().nullish(),
  children: import_zod26.z.coerce.number().nullish(),
  infants: import_zod26.z.coerce.number().nullish(),
  quantity: import_zod26.z.number().nullish(),
  results: import_zod26.z.array(
    import_zod26.z.object({
      offer: viewItemListEventOfferSchema,
      roomType: viewItemListEventRoomTypeSchema,
      property: viewItemListEventPropertySchema
    })
  ),
  pointsConversion: PointsConversionSchema
});

// src/events/view-item-list/view-item-list.ts
var viewItemListEvent = (input) => {
  const {
    listName,
    location,
    currency,
    type,
    category,
    payWith,
    availableProperties,
    availableRooms,
    checkIn,
    checkOut,
    adults,
    children,
    infants,
    quantity,
    results,
    pointsConversion
  } = viewItemListEventSchema.parse(input);
  const numberOfNights = checkIn && checkOut ? (0, import_date_fns10.differenceInDays)(new Date(checkOut), new Date(checkIn)) : quantity;
  return {
    event: "view_item_list" /* VIEW_ITEM_LIST */,
    event_data: {
      action: "view" /* VIEW */,
      component_type: "item_list" /* ITEM_LIST */,
      search_term: location,
      search_type: type,
      search_category: category,
      search_payment_toggle: payWith,
      ...availableProperties && {
        available_property_count: availableProperties
      },
      ...availableRooms && {
        available_room_count: availableRooms
      },
      ...checkIn && {
        start_date: checkIn
      },
      ...checkOut && { end_date: checkOut },
      ...adults && { travellers_adult: adults },
      ...children && { travellers_children: children },
      ...infants && { travellers_infant: infants }
    },
    ecommerce: {
      currency,
      item_list_id: listName.toLowerCase().replaceAll(" ", "_"),
      item_list_name: listName,
      items: results.map(({ property, roomType, offer }, index) => ({
        item_id: property.id,
        item_name: property.name,
        item_brand: void 0,
        item_variant: roomType.name,
        item_category: property.category,
        index,
        quantity: numberOfNights,
        price: (
          // FIXME:
          // eslint-disable-next-line no-nested-ternary
          payWith === "cash" || payWith === "cash and points" ? offer?.charges?.total?.amount.toNumber() : payWith === "points" && offer?.charges?.totalCash?.amount.toNumber() === 0 ? offer?.charges?.total?.amount.toNumber() : offer?.charges?.totalCash?.amount.toNumber()
        ),
        points_value: (
          // FIXME:
          // eslint-disable-next-line no-nested-ternary
          payWith === "cash" || payWith === "cash and points" ? cashToPoints(offer?.charges?.total?.amount, pointsConversion).toNumber() : payWith === "points" && offer?.charges?.totalCash?.amount.toNumber() === 0 ? offer?.charges?.total?.amount.toNumber() : cashToPoints(offer?.charges?.totalCash?.amount, pointsConversion).toNumber()
        ),
        has_offer: property.hasOffer
      }))
    }
  };
};

// src/events/view-promotion/view-promotion.schema.ts
var import_zod27 = require("zod");
var viewPromotionSchema = import_zod27.z.object({
  promotion: import_zod27.z.object({
    name: import_zod27.z.string(),
    slot: import_zod27.z.string(),
    assetName: import_zod27.z.string().nullish()
  }).transform((val) => ({
    ...val,
    id: val.name.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_")
  }))
});

// src/events/view-promotion/view-promotion.ts
var viewPromotionEvent = (input) => {
  const { promotion } = viewPromotionSchema.parse(input);
  return {
    event: "view_promotion" /* VIEW_PROMOTION */,
    event_data: {
      action: "view" /* VIEW */,
      component_type: "promotion_list" /* PROMOTION_LIST */,
      items: [
        {
          promotion_id: promotion.id,
          promotion_name: promotion.name,
          creative_name: promotion.assetName,
          creative_slot: promotion.slot
        }
      ]
    }
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionType,
  ComponentType,
  CreateFilterUpdateEventPayload,
  EventType,
  ItemType,
  PageType,
  PaymentType,
  SearchCategory,
  SearchType,
  SiteId,
  SiteVertical,
  UserStatus,
  addPaymentInfoEvent,
  addToCartEvent,
  beginCheckoutEvent,
  checkoutErrorEvent,
  createAddPaymentInfoEvent,
  createAddToCartEvent,
  createBeginCheckoutEvent,
  createCheckoutErrorEvent,
  createCreditCardAddEvent,
  createCreditCardAddEventPayload,
  createCreditCardApplyEvent,
  createCreditCardApplyEventPayload,
  createCtaClickEvent,
  createCtaClickEventPayload,
  createCustomClickEvent,
  createFilterApplyEvent,
  createFilterOpenEvent,
  createFilterOpenEventPayload,
  createFilterSelectEvent,
  createFilterUpdateEvent,
  createFooterClickEvent,
  createFormCompleteEvent,
  createFormErrorEvent,
  createHolidaysFilterApplyEventPayload,
  createHolidaysFilterSelectEventPayload,
  createHolidaysViewItemListEventPayload,
  createHolidaysViewSearchResultsEventPayload,
  createHotelsAddToCartEventPayload,
  createHotelsBeginCheckoutEventPayload,
  createHotelsOptimizelyFeatureDecisionEventPayload,
  createHotelsPurchaseEventPayload,
  createHotelsSelectItemEventPayload,
  createHotelsViewItemEventPayload,
  createHotelsViewItemListEventPayload,
  createHotelsViewSearchResultsEventPayload,
  createLoginEvent,
  createLoginEventPayload,
  createLogoutEvent,
  createLogoutEventPayload,
  createMapLocationClickEvent,
  createMapLocationClickPayload,
  createMapOpenClickEvent,
  createMapOpenClickEventPayload,
  createMenuClickEvent,
  createModalCloseEvent,
  createModalCloseEventPayload,
  createModalShowEvent,
  createOptimizelyFeatureDecisionEvent,
  createPageViewEvent,
  createPageViewEventPayload,
  createPaginationClickEvent,
  createPaginationClickEventPayload,
  createPromotionCodeApplyEvent,
  createPurchaseEvent,
  createSearchErrorEvent,
  createSearchErrorEventPayload,
  createSearchExitFieldEvent,
  createSearchExitFieldEventPayload,
  createSearchSubmitEvent,
  createSearchSubmitEventPayload,
  createSearchSuggestionClickEvent,
  createSearchSuggestionDisplayEvent,
  createSelectItemEvent,
  createSelectPromotionEvent,
  createSortApplyEvent,
  createSortApplyEventPayload,
  createSortOpenEvent,
  createSortOpenEventPayload,
  createSortSelectEvent,
  createSortSelectEventPayload,
  createTabClickEvent,
  createTabClickEventPayload,
  createTileClickEvent,
  createTileClickEventPayload,
  createUserPayload,
  createViewItemEvent,
  createViewItemListEvent,
  createViewPromotionEvent,
  createViewSearchResultsEvent,
  ctaClickEvent,
  customClickEvent,
  filterUpdateEvent,
  loginEvent,
  logoutEvent,
  menuClickEvent,
  pageViewEvent,
  promotionCodeApplyEvent,
  purchaseEvent,
  searchExitFieldEvent,
  searchSubmitEvent,
  searchSuggestionClickEvent,
  searchSuggestionDisplayEvent,
  selectHolidaysItemEvent,
  selectItemEvent,
  selectPromotionEvent,
  tabClickEvent,
  viewItemEvent,
  viewItemListEvent,
  viewPromotionEvent
});
